(theme.events.onScroll = {
  callbacks: [],
  addEvent: function () {
    var e = !1;
    window.addEventListener(
      "scroll",
      function () {
        e = !0;
      },
      { passive: !0 }
    );
    let t = this;
    setInterval(function () {
      e && ((e = !1), t.callbacks.forEach((e) => e()));
    }, 10);
  },
}),
  (theme.events.shopifyEditor = {
    handleSectionLoad: function (e) {
      var t = JSON.parse(e.target.dataset.shopifyEditorSection);
      switch (t.type) {
        case "header":
          let i = Object.create(theme.component.themeHeader),
            r =
              ((i.header = e.target),
                i.render(),
                theme.search.headerSearch(),
                Object.create(theme.form.customSelect)),
            o =
              ((r.selectEl = e.target.querySelectorAll(".custom-select")),
                r.render(),
                Object.create(theme.navigation));
          (o.container = e.target), o.render();
          break;
        case "announcement-bar":
          var s = e.target.querySelector(".announcement-bar");
          if (s) {
            let a = Object.create(theme.announcementBar);
            (a.element = s), a.render();
          }
          break;
        case "slideshow":
          let c = e.target.querySelector(".slideshow-section");
          if (c) {
            let l = Object.create(theme.slideshow);
            (l.container = c),
              (l.selector = `#${c.getAttribute(
                "id"
              )} .slideshow-section__swiper`),
              l.render();
          }
          break;
        case "collection-list":
          if ((s = e.target.querySelector(".collection-list"))) {
            let d = Object.create(theme.collectionList);
            (d.container = s), d.render();
          }
          break;
        case "menu-flutuante":
          if ((s = e.target.querySelector(".menu-flutuante"))) {
            let u = Object.create(theme.menuFlutuante);
            (u.container = s), u.render();
          }
          break;
        case "product-features":
          if ((s = e.target.querySelector(".product-features"))) {
            let h = Object.create(theme.productFeatures);
            (h.container = s), h.render();
          }
          break;
        case "text-marquee":
          if ((s = e.target.querySelector(".teamdrop-height-observer"))) {
            let h = Object.create(theme.textMarquee);
            (h.container = s), h.render();
          }
          break;
        case "feed-instagram":
          if ((s = e.target.querySelector(".feed-instagram"))) {
            let m = Object.create(theme.feedInstagram);
            (m.container = s), m.render();
          }
          break;
        case "featured-collection":
          if ((s = e.target.querySelector(".featured-collection"))) {
            let p = Object.create(theme.featuredCollection);
            (p.container = s),
              (p.swiperSelector = `[data-section-id="${s.dataset.sectionId}"] .featured-collection__swiper`),
              p.render();
          }
          break;
        case "featured-product":
          if ((s = e.target.querySelector(".featured-product"))) {
            let f = Object.create(theme.featuredProduct);
            (f.element = s), f.render();
          }
          break;
        case "product-recommendations":
          if ((s = e.target.querySelector(".product-recommendations"))) {
            let v = Object.create(theme.productRecommendation);
            (v.container = s),
              (v.swiperSelector = `[data-section-id="${s.dataset.sectionId}"] .product-recommendations__swiper`),
              v.render();
          }
          break;
        case "recent-viewed-product":
          if ((s = e.target.querySelector(".recent-viewed-product"))) {
            let y = Object.create(theme.recentViewedProduct);
            (y.container = s), y.render();
          }
          break;
        case "multicolumn":
          if ((s = e.target.querySelector(".multicolumn"))) {
            let g = Object.create(theme.multicolumn);
            (g.section = s), g.render();
          }
          break;
        case "whatsapp-popup":
          if ((s = e.target.querySelector(".whatsapp-popup"))) {
            let wpp = Object.create(theme.whatsappPopup);
            (wpp.section = s), wpp.render();
          }
          break;
        case "sale-notification":
          if ((s = e.target.querySelector(".sale-notification"))) {
            let S = Object.create(theme.saleNotification);
            (S.section = s), S.render();
          }
          break;
        default:
          console.log("Se\xe7\xe3o n\xe3o tratada:", t.type);
      }
      let L = e.target.querySelectorAll(".ab-tab"),
        w =
          (L.length > 0 &&
            L.forEach(function (e) {
              let t = Object.create(theme.component.tab);
              (t.element = e), t.render();
            }),
            theme.component.renderTooltip(e.target),
            e.target.querySelectorAll(".accordion"));
      w.length > 0 &&
        w.forEach(function (e) {
          let t = Object.create(theme.component.accordion);
          (t.element = e), t.render(e);
        }),
        theme.utilities.applyAnimation(),
        theme.utilities.applyImagesSrcset();
    },
  }),
  (theme.notification = {}),
  (theme.notification.component = {
    duration: 5e3,
    type: null,
    title: null,
    text: null,
    show: function () {
      if (this.type) {
        (this.item = document.createElement("div")),
          this.item.classList.add(
            "notification",
            "notification--" + this.type,
            "mb-1",
            "transition-transform",
            "translate-x-hidden"
          );
        let e = document.createElement("div");
        if ((e.classList.add("notification-content"), this.title)) {
          let t = document.createElement("div");
          t.classList.add("h6"), (t.innerHTML = this.title), e.appendChild(t);
        }
        if (this.text) {
          let i = document.createElement("div");
          (i.innerHTML = this.text), e.appendChild(i);
        }
        let n = document.createElement("div"),
          r =
            (n.classList.add("notification-btn"),
              document.createElement("button"));
        if (
          ((r.innerHTML = window.icons.cross),
            r.addEventListener("click", this.handleBtnClose.bind(this)),
            n.appendChild(r),
            e.appendChild(n),
            this.item.appendChild(e),
            document.querySelector(".notification-container"))
        )
          document.querySelector(".notification-container").append(this.item);
        else {
          let o = document.createElement("div");
          o.classList.add("notification-container"),
            o.appendChild(this.item),
            document.querySelector("body").append(o);
        }
        setTimeout(() => {
          this.item.classList.remove("translate-x-hidden"),
            this.item.classList.add("translate-0");
        }, 300),
          (this.hideByDurationId = setTimeout(() => {
            this.hide();
          }, this.duration));
      }
    },
    handleBtnClose: function (e) {
      e.preventDefault(), clearTimeout(this.hideByDurationId), this.hide();
    },
    hide: function () {
      this.item.classList.add("translate-x-hidden"),
        this.item.classList.remove("translate-0"),
        setTimeout(() => {
          this.item.remove();
        }, 1e3);
    },
  }),
  (theme.notification.error = function (e, t) {
    let i = Object.create(theme.notification.component);
    (i.type = "error"), (i.title = e), (i.text = t), i.show();
  }),
  (theme.notification.success = function (e, t) {
    let i = Object.create(theme.notification.component);
    (i.type = "success"), (i.title = e), (i.text = t), i.show();
  }),
  (theme.notification.info = function (e, t) {
    let i = Object.create(theme.notification.component);
    (i.type = "info"), (i.title = e), (i.text = t), i.show();
  }),
  (theme.notification.warning = function (e, t) {
    let i = Object.create(theme.notification.component);
    (i.type = "warning"), (i.title = e), (i.text = t), i.show();
  }),
  (theme.product = {
    init: function () {
      document
        .querySelectorAll("#product-grid .product-card")
        .forEach(function (e) {
          let t = Object.create(theme.product.card);
          (t.item = e), t.render();
        }),
        this.mainPage.render();
    },
    customSwatchColors: function () {
      let e = window.themeSettings.productColors.split(","),
        t = {};
      return (
        e.forEach((e) => {
          var i = (e = e.split(":"))[0].trim();
          (e = e[1].trim()), (t[i] = e);
        }),
        t
      );
    },
  }),
  (theme.product.card = {
    item: void 0,
    forms: null,
    render: function () {
      if (this.item) {
        let e = this,
          t =
            ((this.forms = this.forms || this.item.querySelectorAll("form")),
              0 < this.forms.length &&
              this.forms.forEach((e) => {
                let t = Object.create(theme.product.form);
                (t.form = e), t.render();
              }),
              this.item.querySelector(".product-card__swatches"));

        t &&
          t.querySelectorAll('input[type="radio"]').forEach((i) => {
            i.addEventListener("change", e.handleVariantChange.bind(e));
            let n = t.querySelector(`label[for="${i.getAttribute("id")}"]`);
            (i = n.dataset.swatch.toLowerCase()),
              (i = theme.product.customSwatchColors()[i]) &&
              (n.style.cssText = "--swatch-background-color: " + i);
          });

        this.item.setAttribute("card-rendered", "");
      }
    },
    handleVariantChange: function (e) {
      e.preventDefault();
      let t = e.currentTarget;
      e = t.value;
      var i = parseInt(t.dataset.optionPosition) - 1;
      let n = this.getSelectedVariantData(e, i),
        r = t.closest(".product-card"),
        o =
          (r
            .querySelectorAll(".variant-img")
            .forEach((e) => e.classList.remove("variant-img--active")),
            r.querySelector(`[data-variant-image="${n.id}"]`));
      o &&
        (o.querySelector(".variant-img").classList.add("variant-img--active"),
          this.forms &&
          this.forms.forEach((e) => {
            e.querySelector('input[name="id"]').value = n.id;
          }));
    },
    getSelectedVariantData: function (e, t) {
      return this.getVariantData().find((i) => i.options[t] === e);
    },
    getVariantData: function () {
      return (
        (this.variantData =
          this.variantData ||
          JSON.parse(
            this.item.querySelector('[type="application/json"]').textContent
          )),
        this.variantData
      );
    },
  }),
  (theme.product.form = {
    sectionId: "",
    form: null,
    render: function () {
      this.form &&
        ((this.form.querySelector("input[name=id]").disabled = !1),
          this.form.addEventListener("submit", this.submitHandler.bind(this)),
          (this.errorMsgElement = this.form.querySelector(".field-msg")));
    },
    submitHandler: function (e) {
      e.preventDefault();
      let t = e.submitter || this.form.querySelector(".product-form__submit");
      this.showLoader(t), this.hideErrorMsg();
      const isFormInsideCartDrawer = !!this.form.closest('#cartDrawer');
      let i = new FormData(this.form),
        n = theme.utilities.fetchConfig("javascript");
      (n.headers["X-Requested-With"] = "XMLHttpRequest"),
        delete n.headers["Content-Type"],
        (n.body = i),
        fetch("" + routes.cart_add_url, n)
          .then((e) => e.json())
          .then((e) => {
            if (e.status) this.handleError(e.description);
            else {
              let i = document.querySelector(".product-quickview");
              let isFromCartDrawer = false;

              if (i && i.hasAttribute('data-from-cart-drawer')) {
                isFromCartDrawer = true;
              }

              if (i) {
                i.classList.add("fade-out");
                setTimeout(() => {
                  i.remove();

                  if (!isFromCartDrawer) {
                    document.querySelector("body").classList.remove("noscroll");
                  }
                }, 300);
              }

              if (t.classList.contains("buy-now")) {
                window.location.href = "/cart";
                return;
              }

            if (isFromCartDrawer || isFormInsideCartDrawer) {
                theme.cart.drawer.reloadCart();
              } else if (document.getElementById("ajaxDrawer")) {
                theme.cart.drawer.openDrawer();
              } else {
                window.location.href = "/cart";
              }
            }
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            setTimeout(() => this.hideLoader(t), 500);
          });
    },
    handleError: function (e = !1) {
      (this.errorMsgElement.querySelector("span").innerHTML = e),
        this.errorMsgElement.classList.remove("d-none");
    },
    hideErrorMsg: function () {
      this.errorMsgElement && this.errorMsgElement.classList.add("d-none");
    },
    showLoader: function (e) {
      e.classList.add("with-loader--show");
      let t = e.querySelector(".spinner");
      t && t.classList.add("animating");
    },
    hideLoader: function (e) {
      e.classList.remove("with-loader--show");
      let t = e.querySelector(".spinner");
      t && t.classList.remove("animating");
    },
    disableBuyButton: function () {
      document.querySelectorAll(".product-form__submit").forEach((e) => {
        e.setAttribute("disabled", !0);
        let t = e.querySelector("span");
        t && (t.textContent = window.accessibilityStrings.soldOut);
      });
    },
    enableBuyButton: function () {
      document.querySelectorAll(".product-form__submit").forEach((e) => {
        e.removeAttribute("disabled");
        let t = e.querySelector("span");
        t &&
          (e.classList.contains("buy-now")
            ? (t.textContent = window.accessibilityStrings.buyNow)
            : (t.textContent = window.accessibilityStrings.addToCart));
      });
    },
  }),
  (theme.product.quickview = {
    init: function () {
      this.bindEvents();
    },

    bindEvents: function () {
      document.addEventListener("click", (e) => {
        const button = e.target.closest(".product-qv-btn");
        if (!button) return;

        e.preventDefault();
        this.getModalContent(e);
      });
    },
    getModalContent: function (e) {
      e.preventDefault();

      const button = e.target.closest(".product-qv-btn");
      const spinner = button.querySelector(".spinner");

      if (spinner) {
        button.classList.add("with-loader--show");
        spinner.classList.add("animating");
      }
      button.disabled = true;

      const quickviewUrl = button.dataset.quickviewUrl;
      if (!quickviewUrl) {
        this.resetButtonState(button, spinner);
        return;
      }

      fetch(window.location.origin + quickviewUrl)
        .then((response) => {
          if (!response.ok) throw new Error("Erro ao carregar Quick View");
          return response.text();
        })
        .then((html) => {
          this.showModal(html);
          setTimeout(() => {
            this.resetButtonState(button, spinner);
          }, 300);
        })
        .catch((error) => {
          console.error("Erro ao buscar Quick View:", error);
          this.resetButtonState(button, spinner);
        });
    },

    resetButtonState: function (button, spinner) {
      button.disabled = false;
      button.classList.remove("with-loader--show");
      if (spinner) {
        spinner.classList.remove("animating");
      }
    },

    showModal: function (html) {
      if (this.productQuickview && this.productQuickview.parentNode) {
        this.productQuickview.remove();
      }

      const parsedHTML = new DOMParser().parseFromString(html, "text/html");
      this.productQuickview = parsedHTML.querySelector(".product-quickview");
      const sectionId = this.productQuickview.dataset.sectionId;

      const cartDrawer = document.querySelector('#cartDrawer');
      if (cartDrawer && cartDrawer.classList.contains('activated')) {
        this.productQuickview.setAttribute('data-from-cart-drawer', 'true');
      }

      const productImages = this.productQuickview.getElementsByClassName("pr-image");

      document.querySelector("body").append(this.productQuickview);

      this.productQuickview.setAttribute("data-action", "modal-quickview");
      theme.component.modal.openModal("quickview");

      theme.utilities.imagesSrcset(productImages);
      const productForm = this.productQuickview.querySelector(".product-form");

      const formInstance = Object.create(theme.product.form);
      formInstance.form = productForm;
      formInstance.render();
      Shopify.PaymentButton.init();
      (window._themeProducts = window._themeProducts || {});
      window._themeProducts[this.productQuickview.dataset.productId] = JSON.parse(
        this.productQuickview.querySelector('#ProductData[type="application/json"]').textContent
      );

      theme.utilities.applyAnimation();
      let o = Object.create(theme.product.imageSlider);
      o.sliderSelector = `.product-quickview[data-section-id="${sectionId}"] .product-media__swiper`;
      o.productId = this.productQuickview.dataset.productId;
      o.sectionId = this.productQuickview.dataset.sectionId;
      let r = o.render();

      this.productQuickview.addEventListener("click", (e) => {
        if (!e.target.closest(".product-quickview__container")) {
          this.closeModal(e);
        }
      });
      let s = Object.create(theme.product.variant);
      s.productVariant = this.productQuickview.querySelector(".product-variant");
      s.imageSlider = r; 
      s.form = formInstance;
      s.sections = [{
        sectionId: this.productQuickview.dataset.sectionId,
        selectors: ["#price-" + this.productQuickview.dataset.sectionId]
      }];
      s.render();

      theme.component.renderTooltip(this.productQuickview);
    },
    closeModal: function (e) {
      e && e.preventDefault();

      theme.component.modal.closeModal("quickview");

      setTimeout(() => {
        if (this.productQuickview && this.productQuickview.parentNode) {
          this.productQuickview.remove();
        }
        this.productQuickview = null;
      }, 300);
    },
  }),
  (theme.product.quantityInput = {
    wrapper: null,
    element: null,
    render: function () {
      let e = this;
      this.wrapper &&
        Array.from(
          this.wrapper.getElementsByClassName("product-quantity")
        ).forEach(function (t) {
          Array.from(t.getElementsByTagName("button")).forEach((t) => {
            t.addEventListener("click", e.handleOnClick.bind(e));
          });
        }),
        this.element &&
        this.element.querySelectorAll("button").forEach((t) => {
          t.addEventListener("click", e.handleOnClick.bind(e));
        });
    },
    handleOnClick: function (e) {
      e.preventDefault();
      let t = e.currentTarget
        .closest(".product-quantity")
        .querySelector("input");
      if ("minus" === e.currentTarget.name && 1 === parseInt(t.value)) {
        let i = e.currentTarget
          .closest(".cart-item")
          .querySelector(".js-item-remove");
        if (i) return void i.click();
      }
      "plus" === e.currentTarget.name ? t.stepUp() : t.stepDown(),
        this.toggleButton(e.currentTarget),
        t.dispatchEvent(new Event("change"));
    },
    toggleButton: function (e) {
      var t = e.closest(".product-quantity").querySelector("input");
      let i = e
        .closest(".product-quantity")
        .querySelector('button[name="minus"]');
      1 === parseInt(t.value) ? (i.disabled = !0) : (i.disabled = !1);
    },
  }),
  (theme.product.variant = {
    productVariant: null,
    imageSlider: null,
    form: null,
    selectedVariant: null,
    selectedOptions: null,
    availableVariant: null,
    variantData: null,
    updateUrlOnVariantChanged: !1,
    sections: null,
    render: function () {
      if (this.productVariant) {
        let e = this;
        (this.productUrl = this.productVariant.dataset.url),
          (this.sectionId = this.productVariant.dataset.section),
          (this.optionStyle = this.productVariant.dataset.style),
          (this.firstOptionContainer = this.productVariant.querySelector(
            '.product-variant__option[data-option-index="1"]'
          )),
          (this.optionContainer = this.productVariant.querySelectorAll(
            ".product-variant__option"
          )),
          this.firstOptionContainer &&
          ("swatches" === this.optionStyle
            ? ((this.options = this.productVariant.querySelectorAll(
              'input[type="radio"]'
            )),
              this.firstOptionContainer
                .querySelectorAll('input[type="radio"]')
                .forEach((t) => {
                  t.addEventListener(
                    "change",
                    e.handleFirstOptionChange.bind(e)
                  );
                  let i = e.productVariant.querySelector(
                    `label[for="${t.getAttribute("id")}"]`
                  );
                  i.classList.contains("label--tag") ||
                    ((t = i.dataset.swatch.toLowerCase()),
                      (t = theme.product.customSwatchColors()[t]) &&
                      (i.style.cssText = "--swatch-background-color: " + t));
                }),
              this.optionContainer.forEach((t) => {
                t.querySelectorAll('input[type="radio"]').forEach((t) => {
                  t.addEventListener("change", e.handleVariantChange.bind(e));
                });
              }))
            : ((this.options =
              this.productVariant.querySelectorAll("select")),
              this.firstOptionContainer
                .querySelector("select")
                .addEventListener(
                  "change",
                  e.handleFirstOptionChange.bind(e)
                ),
              this.options.forEach((t) => {
                t.addEventListener("change", e.handleVariantChange.bind(e));
              })),
            (this.selectedOptions = this.getSelectedOptions()),
            (this.selectedVariant = this.getSelectedVariantData(
              this.selectedOptions
            )),
            (this.availableVariant =
              "swatches" === this.optionStyle
                ? this.getAvailableVariant(
                  this.firstOptionContainer.querySelector("input:checked")
                )
                : this.getAvailableVariant(
                  this.firstOptionContainer.querySelector("select")
                )),
            this.setAvailableOption(),
            this.getAvailableFirstOptions());
      }
    },
    handleFirstOptionChange: function (e) {
      (this.availableVariant = this.getAvailableVariant(e.target)),
        this.setAvailableOption();
    },
    handleVariantChange: function (e) {
      if (
        ((this.selectedOptions = this.getSelectedOptions()),
          (this.selectedVariant = this.getSelectedVariantData(
            this.selectedOptions
          )),
          this.updateMedia(),
          this.selectedVariant && this.selectedVariant.available
            ? (this.updateVariantInput(),
              this.updateUrlOnVariantChanged && this.updateURL(),
              this.renderProductInfo(),
              this.form && this.form.enableBuyButton(),
              this.updateAllProductVariantElement(
                e.target.closest(
                  `.product-variant[data-section="${this.sectionId}"]`
                )
              ))
            : this.form && this.form.disableBuyButton(),
          "swatches" === this.optionStyle)
      ) {
        let t = e.target;
        t
          .closest(".product-variant__option")
          .querySelector(".selected-option-variant").innerHTML = t.value;
      }
    },
    getAvailableVariant: function (e) {
      return this.getVariantData().filter((t) => t.option1 === e.value);
    },
    setAvailableOption: function () {
      let e = this.availableVariant;
      "swatches" === this.optionStyle
        ? Array.from(this.optionContainer)
          .slice(1)
          .forEach((t, i) => {
            t.querySelectorAll('input[type="radio"]').forEach((t) => {
              0 ===
                e.filter((e) => e.options[i + 1] === t.value && e.available)
                  .length
                ? t.classList.add("product-variant__input--unavailable")
                : t.classList.remove("product-variant__input--unavailable");
            });
          })
        : Array.from(this.options)
          .slice(1)
          .forEach((t, i) => {
            t.querySelectorAll("option").forEach((t) => {
              0 ===
                e.filter((e) => e.options[i + 1] === t.value && e.available)
                  .length
                ? t.setAttribute("disabled", !0)
                : t.removeAttribute("disabled");
            });
          });
    },
    getSelectedOptions: function () {
      return "swatches" === this.optionStyle
        ? Array.from(this.options)
          .filter((e) => e.checked)
          .map((e) => e.value)
        : Array.from(this.productVariant.querySelectorAll("select")).map(
          (e) => e.value
        );
    },
    getSelectedVariantData: function (e) {
      return this.getVariantData().find(
        (t) => !t.options.map((t, i) => e[i] === t).includes(!1)
      );
    },
    getAvailableFirstOptions: function () {
      1 < this.optionContainer.length ||
        (1 === this.optionContainer.length &&
          ("swatches" === this.optionStyle
            ? this.optionContainer[0]
              .querySelectorAll('input[type="radio"]')
              .forEach((e) => {
                this.getVariantData().find(
                  (t) => t.option1 === e.value && t.available
                )
                  ? e.classList.remove("product-variant__input--unavailable")
                  : e.classList.add("product-variant__input--unavailable");
              })
            : this.optionContainer[0]
              .querySelectorAll("option")
              .forEach((e) => {
                this.getVariantData().find(
                  (t) => t.option1 === e.value && t.available
                )
                  ? e.removeAttribute("disabled")
                  : e.setAttribute("disabled", !0);
              })));
    },
    updateURL: function () {
      this.selectedVariant &&
        !1 !== this.productVariant.dataset.updateUrl &&
        window.history.replaceState(
          {},
          "",
          this.productUrl + "?variant=" + this.selectedVariant.id
        );
    },
    updateMedia: function () {
      var e;
      this.selectedVariant &&
        this.selectedVariant.featured_media &&
        (e = document.querySelector(
          `[data-media-id="${this.sectionId}-${this.selectedVariant.featured_media.id}"]`
        )) &&
        this.imageSlider &&
        ((e = parseInt(e.dataset.index)),
          this.imageSlider.slideToLoop(parseInt(e), 600));
    },
    updateVariantInput: function () {
      let e = this;
      document
        .querySelectorAll("#product-form-" + this.sectionId)
        .forEach((t) => {
          let i = t.querySelector('input[name="id"]');
          (i.value = e.selectedVariant.id),
            i.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    },
    renderStickyFormVariant: function () {
      (this.productUrl = this.productVariant.dataset.url),
        (this.productId = this.productVariant.dataset.productId),
        (this.sectionId = this.productVariant.dataset.section);
      let e = this.productVariant.querySelector(".product-variant__select"),
        t = this.getVariantData();
      e.querySelectorAll("option").forEach((e) => {
        t.find((t) => t.id === parseInt(e.value) && t.available)
          ? e.removeAttribute("disabled")
          : e.setAttribute("disabled", !0);
      }),
        e.addEventListener(
          "change",
          this.handleStickyFormVariantChange.bind(this)
        );
    },
    handleStickyFormVariantChange: function (e) {
      let t = parseInt(e.target.value);
      (this.selectedVariant = this.getVariantData().find((e) => e.id === t)),
        this.selectedVariant && this.selectedVariant.available
          ? (this.updateVariantInput(),
            this.updateUrlOnVariantChanged && this.updateURL(),
            this.renderProductInfo(),
            this.form && this.form.enableBuyButton(),
            this.updateAllProductVariantElement(
              e.target.closest(
                `.product-variant[data-section="${this.sectionId}"]`
              )
            ))
          : this.form && this.form.disableBuyButton();
    },
    updateAllProductVariantElement: function (e) {
      let t = document.querySelectorAll(
        `.product-variant[data-section="${this.sectionId}"]`
      ),
        i = this;
      t.forEach((t) => {
        t != e &&
          ("swatches" === t.dataset.style
            ? t.querySelectorAll(".product-variant__inputs").forEach((e, t) => {
              e.querySelectorAll('input[type="radio"]').forEach((e) => {
                e.value === i.selectedVariant.options[t]
                  ? (e.checked = !0)
                  : (e.checked = !1);
              });
            })
            : t.querySelectorAll("select").forEach((e, t) => {
              Array.from(e.querySelectorAll("option"))
                .map((e) => parseInt(e.value))
                .includes(i.selectedVariant.id)
                ? (e.value = i.selectedVariant.id)
                : (e.value = i.selectedVariant.options[t]);
            }));
      });
    },
    renderProductInfo: function () {
      let e = this;
      var t = this.sections.map((e) => e.sectionId).join(",");
      fetch(
        `${this.productUrl}?variant=${this.selectedVariant.id}&sections=` + t
      )
        .then((e) => e.json())
        .then((t) => {
          e.sections.forEach((e) => {
            let i = new DOMParser().parseFromString(
              t[e.sectionId],
              "text/html"
            );
            e.selectors.forEach((e) => {
              let t = document.querySelector(e),
                n = i.querySelector(e);
              t && n && (t.innerHTML = n.innerHTML);
            });
          });
        });
    },
    getVariantData: function () {
      return (
        (this.variantData =
          this.variantData ||
          JSON.parse(
            this.productVariant.querySelector('[type="application/json"]')
              .textContent
          )),
        this.variantData
      );
    },
  }),
  (theme.product.imageSlider = {
    sliderSelector: void 0,
    sliderNavSelector: void 0,
    productId: void 0,
    sectionId: void 0,
    render: function () {
      if (
        ((this.sliders = document.querySelector(this.sliderSelector)),
          this.sliders)
      ) {
        var e = window._themeProducts[this.productId];
        let t = !1;
        var i = document.querySelector(this.sliderNavSelector),
          n =
            (i &&
              ((n =
                "horizontal" === (i = i.dataset.sliderDirection) ? 6 : "auto"),
                (t = {
                  swiper: (i = new Swiper(this.sliderNavSelector, {
                    spaceBetween: 8,
                    slidesPerView: n,
                    watchSlidesProgress: !0,
                    direction: i,
                    navigation: {
                      nextEl:
                        this.sliderNavSelector + " .swiper-nav-thumbnail-next",
                      prevEl:
                        this.sliderNavSelector + " .swiper-nav-thumbnail-prev",
                    },
                    breakpoints: { 768: { slidesPerView: n, spaceBetween: 12 } },
                    on: {
                      afterInit: function () {
                        theme.utilities.applyAnimation();
                      },
                      loopFix: function () {
                        theme.utilities.applyAnimation();
                      },
                    },
                  })),
                })),
              this.getInitialSlideIndex(e.selected_or_first_available_variant));
        return new Swiper(this.sliderSelector, {
          spaceBetween: 10,
          loop: !0,
          initialSlide: n,
          navigation: {
            nextEl: this.sliderSelector + " .swiper-nav-next",
            prevEl: this.sliderSelector + " .swiper-nav-prev",
          },
          pagination: {
            el: this.sliderSelector + " .product-media-pagination",
            type: "fraction",
          },
          thumbs: t,
          on: {
            afterInit: function () {
              theme.utilities.applyAnimation();
            },
            loopFix: function () {
              theme.utilities.applyAnimation();
            },
          },
        });
      }
    },
    getInitialSlideIndex: function (e) {
      return window.location.search.includes("?variant=") && e.featured_media
        ? ((e = e.featured_media.id),
          parseInt(
            (e = this.sliders.querySelector(
              `[data-media-id=${this.sectionId}-${e}]`
            )).dataset.index
          ))
        : 0;
    },
  }),
  (theme.product.mainPage = {
    mainProduct: document.querySelector(".main-product .product-detail"),
    mainSwiperSelector: ".product-media__swiper",
    navSwiperSelector: ".product-media__nav-swiper",
    render: function () {
      if (this.mainProduct) {
        let e = Object.create(theme.product.imageSlider);
        (e.sliderSelector =
          `#${this.mainProduct.getAttribute("id")} ` + this.mainSwiperSelector),
          (e.sliderNavSelector =
            `#${this.mainProduct.getAttribute("id")} ` +
            this.navSwiperSelector),
          (e.productId = this.mainProduct.dataset.productId),
          (e.sectionId = this.mainProduct.dataset.sectionId);
        var t = e.render();
        this.setMediaContainerHeight(),
          window.addEventListener(
            "resize",
            this.setMediaContainerHeight.bind(this)
          );
        let i = Object.create(theme.product.form),
          n =
            ((i.form = this.mainProduct.querySelector(".product-form")),
              i.render(),
              [
                "#price-" + this.mainProduct.dataset.sectionId,
                "#stock-" + this.mainProduct.dataset.sectionId,
              ]),
          r = document.querySelector(".product-sticky");
        if (r) {
          this.renderStickyForm(r),
            n.push(".product-sticky .js-contents");
          var o = r.querySelector(".product-quantity");
          if (o) {
            let s = Object.create(theme.product.quantityInput);
            (s.element = o), s.render();
          }
        }
        o = [{ sectionId: this.mainProduct.dataset.sectionId, selectors: n }];
        let a = Object.create(theme.product.variant);
        if (
          ((a.productVariant =
            this.mainProduct.querySelector(".product-variant")),
            (a.imageSlider = t),
            (a.form = i),
            (a.updateUrlOnVariantChanged = !0),
            (a.sections = o),
            a.render(),
            r)
        ) {
          let c = Object.create(theme.product.form);
          if (
            ((c.form = r.querySelector(".product-form")),
              (c.handleError = function (e = !1) {
                theme.notification.error(window.cartStrings.cannotUpdateCart, e);
              }),
              c.render(),
              r?.querySelector(".product-variant"))
          ) {
            let l = Object.create(theme.product.variant);
            (l.productVariant = r.querySelector(".product-variant")),
              (l.sections = o),
              (l.form = c),
              (l.updateUrlOnVariantChanged = !0),
              l.renderStickyFormVariant();
          }
        }
        if (
          (t = this.mainProduct.querySelector(".product-detail__buy-buttons"))
        ) {
          let d = Object.create(theme.product.quantityInput);
          (d.wrapper = t), d.render();
        }
        if ("true" === this.mainProduct.dataset.enabledZoom) {
          this.photoSwipeContainer = this.mainProduct;
          
          const zoomButton = this.mainProduct.querySelector('.product-button__zoom');
          if (zoomButton) {
            zoomButton.addEventListener('click', (e) => {
              e.preventDefault();
              
              if (!window.PhotoSwipe) {
                let photoSwipe = Object.create(theme.photoSwipe);
                photoSwipe.init(this.photoSwipeContainer);
                
                const checkLoaded = () => {
                  if (window.PhotoSwipe) {
                    const activeSlide = this.mainProduct.querySelector('.swiper-slide-active');
                    const activeIndex = activeSlide ? parseInt(activeSlide.dataset.index) : 0;
                    photoSwipe.openGallery(activeIndex);
                  } else {
                    setTimeout(checkLoaded, 50);
                  }
                };
                checkLoaded();
              } else {
                let photoSwipe = Object.create(theme.photoSwipe);
                photoSwipe.container = this.photoSwipeContainer;
                
                const activeSlide = this.mainProduct.querySelector('.swiper-slide-active');
                const activeIndex = activeSlide ? parseInt(activeSlide.dataset.index) : 0;
                photoSwipe.openGallery(activeIndex);
              }
            });
          }
        }
        this.addRecentViewProduct();
      }
    },
    setSlider: function () { },
    renderStickyForm: function (e) {
      let t = this.mainProduct.querySelector(".product-form");
      theme.events.onScroll.callbacks.push(
        theme.utilities.debounce(function () {
          t.getBoundingClientRect().top < 0
            ? e.classList.remove("translate-y-b-hidden")
            : e.classList.add("translate-y-b-hidden");
        }, 300)
      );
    },
    setMediaContainerHeight: function () {
      let e = this.mainProduct.querySelector(".product-media"),
        t = e.querySelector(".thumbnail-left, .thumbnail-right");
      if (t) {
        let i = e.querySelector(".product-media__swiper");
        if (i) {
          let mediaElement = i.querySelector(".media");
          let stickyElement = e.querySelector(".product-media-sticky");
          let paddingOffset = 0;
          
          if (stickyElement) {
            let computedStyle = window.getComputedStyle(stickyElement);
            let paddingTop = parseFloat(computedStyle.paddingTop) || 0;
            let paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
            paddingOffset = paddingTop + paddingBottom;
          }
          
          t.style.height = (mediaElement.offsetHeight + paddingOffset) + "px";
        }
      }
    },
    addRecentViewProduct: function () {
      var e = this.mainProduct.dataset.productId;
      let t = theme.utilities.getListFromStorage(
        theme.storageKeys.recentViewedProduct
      );

      t = t.filter(productId => productId !== e);

      t.unshift(e);

      const maxItems = 20;
      if (t.length > maxItems) {
        t = t.slice(0, maxItems);
      }

      window.localStorage.setItem(
        theme.storageKeys.recentViewedProduct,
        JSON.stringify(t)
      );
    },
  }),
  (theme.form = {
    render: function () {
      let e = Object.create(theme.form.customSelect);
      (e.selectEl = document.querySelectorAll(
        ".custom-select:not(.custom-select--rendered)"
      )),
        e.render(),
        e.setListener();
    },
    customSelect: {
      selectEl: null,
      render: function () {
        if (
          ((this.selectEl =
            this.selectEl || document.querySelectorAll(".custom-select")),
            0 !== this.selectEl.length)
        ) {
          let e, t, i, n, r, o, s;
          this.selectEl.forEach(function (a) {
            (e = a.querySelector("select")),
              (i = document.createElement("div")).classList.add(
                "options-container",
                "hide"
              ),
              a.appendChild(i),
              (n =
                (n = e.querySelector("option[selected]")) ||
                e.querySelector("option")),
              (o = document.createElement("span")).classList.add(
                "selected-value"
              ),
              (o.innerHTML = n.innerHTML),
              (s = document.createElement("span")).classList.add(
                "select-arrow"
              ),
              (s.innerHTML =
                '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>'),
              (r = document.createElement("div")),
              a.appendChild(r),
              r.classList.add("select-bar"),
              r.appendChild(o),
              r.appendChild(s),
              Array.from(e.options).forEach(function (e, n) {
                (t = document.createElement("div")).classList.add(
                  "option-item"
                ),
                  e.getAttribute("selected") &&
                  t.classList.add("item-selected"),
                  (t.innerHTML = e.innerHTML),
                  (t.dataset.index = n),
                  i.appendChild(t);
              }),
              i.getBoundingClientRect().x + i.offsetWidth > window.innerWidth &&
              i.classList.add("right-0"),
              a.classList.add("custom-select--rendered");
          });
        }
      },
      setListener: function () {
        (this.handleDocumentClick = this.handleClickEvent.bind(this)),
          document.addEventListener("click", this.handleDocumentClick);
      },
      handleOptionClick: function (e) {
        let t = e.closest(".custom-select").querySelector("select");
        (t.value = t.options[e.dataset.index].value),
          t.dispatchEvent(new Event("change", { bubbles: !0 })),
          (e
            .closest(".custom-select")
            .querySelector(".select-bar span").innerHTML = e.innerHTML),
          this.closeDropdown(e.closest(".custom-select"));
      },
      toggleOpen: function (e) {
        e.classList.toggle("open"),
          e.querySelector(".options-container").classList.toggle("hide"),
          e.querySelector(".select-bar").classList.toggle("active");
        let t = this;
        e.classList.contains("open") &&
          document.querySelectorAll(".custom-select.open").forEach((i) => {
            i !== e && t.closeDropdown(i);
          });
      },
      closeDropdown: function (e) {
        e.classList.remove("open"),
          e.querySelector(".options-container").classList.add("hide"),
          e.querySelector(".select-bar").classList.remove("active");
      },
      handleClickEvent: function (e) {
        let t = this;
        e.target.closest(".custom-select")
          ? e.target.classList.contains("option-item")
            ? this.handleOptionClick(e.target)
            : ((e = e.target.closest(".custom-select")), this.toggleOpen(e))
          : document.querySelectorAll(".custom-select.open").forEach((e) => {
            t.closeDropdown(e);
          });
      },
    },
  }),
  (theme.cart = {
    init: function () {
      this.mainPage.render();
    },
    total_items: document.querySelector(".js-cart-counter")
      ? parseInt(document.querySelector(".js-cart-counter").innerHTML)
      : 0,
    updateTotalItems: function (e) {
      (this.total_items = e),
        document.querySelectorAll(".js-cart-counter").forEach((t) => {
          0 === (t.innerHTML = e)
            ? t.classList.add("d-none")
            : t.classList.remove("d-none");
        });
    },
    calculateTotalItem: function (e) {
      0 < (e = e.querySelectorAll(".product-quantity__input")).length &&
        ((e = Array.from(e)
          .map((e) => parseInt(e.value))
          .reduce((e, t) => e + t)),
          theme.cart.updateTotalItems(e));
    },
    setItemEventListener: function (e) {
      e.querySelector(".product-quantity__input").addEventListener(
        "change",
        theme.utilities.debounce(
          theme.cart.changeQuantity.bind(theme.cart),
          300
        )
      );
      var t = e.querySelector(".cart-item__quantity");
      theme.cart.inputQuantity(t),
        e
          .querySelector(".js-item-remove")
          .addEventListener("click", this.removeItem.bind(this));
    },
    changeQuantity: function (e) {
      let t = this,
        i = e.target,
        n = i.classList.contains("product-quantity__button--decrement");
      e = parseInt(i.value);
      let r = i.dataset.variantId,
        o =
          (i
            .closest(".product-quantity")
            .querySelectorAll(".product-quantity__button")
            .forEach(function (e) {
              e.disabled = !0;
            }),
            this.showLoading(i),
            i.closest(".cart-item-" + r));
      if (n && 1 === e)
        return void this.removeItem({
          currentTarget: o.querySelector(".js-item-remove"),
        });
      let s = JSON.stringify({
        id: r,
        quantity: e,
        sections: this.getSectionsToRender().map((e) => e.sectionId),
        sections_url: window.location.pathname,
      }),
        a = this.getSectionsToRender().find((e) => o.closest(e.id));
      fetch("" + routes.cart_change_url, {
        ...theme.utilities.fetchConfig(),
        body: s,
      })
        .then((e) => e.json())
        .then(async (e) => {
          if (e.errors) {
            theme.notification.error(
              window.cartStrings.cannotUpdateCart,
              e.errors
            );
            t.refreshItem(a.sectionId, o);
          } else {
            if (document.querySelector("#cartDrawer")) {
              theme.cart.drawer.reloadCart();
            } else {
              t.updateTotalItems(e.item_count);
              t.renderItem(e, r);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    removeItem: function (e) {
      e.preventDefault();
      let t = e.currentTarget.closest(".cart-item");
      let variantId = t.dataset.variantId;
      let quantityInput = t.querySelector(".product-quantity__input");
      let cartItems = document.querySelectorAll(".cart-item-" + variantId);

      cartItems.forEach((item) => {
        item.classList.add("opacity-0");
      });

      quantityInput.value = 0;
      quantityInput.dispatchEvent(new Event("change"));

      cartItems.forEach((item) => {
        setTimeout(() => {
          item.remove();

          let remainingItems = document.querySelectorAll(".cart-item");
          if (remainingItems.length === 0) {
            theme.cart.updateTotalItems(0);
          }
        }, 1000);
      });
    },
    showLoading: function (e) {
      let t = e.closest(".cart-item");
      if (t) {
        let i = t.querySelector(".loading-overlay");
        i &&
          (i.classList.remove("d-none"),
            i.querySelector(".spinner").classList.add("animating"));
      }
    },
    hideLoading: function (e) {
      let t = e.closest(".cart-item");
      if (t) {
        let i = t.querySelector(".loading-overlay");
        i &&
          (i.classList.add("d-none"),
            i.querySelector(".spinner").classList.remove("animating"));
      }
    },
    refreshItem: async function (e, t) {
      return fetch("?section_id=" + e)
        .then((e) => e.text())
        .then((e) => {
          let i = new DOMParser().parseFromString(e, "text/html");
          (t.innerHTML = i.querySelector(
            ".cart-item-" + t.dataset.variantId
          ).innerHTML),
            this.setItemEventListener(t);
        });
    },
    renderItem: function (e, t) {
      this.getSectionsToRender().forEach((i) => {
        if (Object.keys(e.sections).includes(i.sectionId)) {
          let n = i.itemsContainer;
          var r = i.sectionId;
          if (e.items.map((e) => e.id).includes(parseInt(t))) {
            let o = n.querySelector(".cart-item-" + t);
            o.querySelector(".cart-item__total") &&
              (o.querySelector(".cart-item__total").innerHTML =
                this.getSectionInnerHTML(
                  e.sections[r],
                  `.cart-item-${t} .cart-item__total`
                )),
              (o.querySelector(".cart-item__quantity").innerHTML =
                this.getSectionInnerHTML(
                  e.sections[r],
                  `.cart-item-${t} .cart-item__quantity`
                )),
              this.setItemEventListener(o);
          }
          e.items.length > 0
            ? (this.renderFooter(e, i), this.renderShippingBar(e, i))
            : (this.renderEmptyCart(e, i), this.removeShippingBar(i));
        }
      });
    },
    renderFooter: function (e, t) {
      var i = ".js-cart-subtotal";
      (t && (e = this.getSectionInnerHTML(e.sections[t.sectionId], i)), t && e)
        ? t.node.querySelectorAll(i).forEach((t) => {
          t.innerHTML = e;
        })
        : t &&
        (t.node.classList.add("opacity-0", "transition-opacity"),
          setTimeout(() => {
            t.node.remove();
          }, 500));
    },
    renderShippingBar: function (e, t) {
      var i = ".shipping-cart-bar";
      if (t && e) {
        let n = t.node.querySelector(i);
        n &&
          ((e = this.getSectionInnerHTML(e.sections[t.sectionId], i)),
            (n.innerHTML = e));
      }
    },
    removeShippingBar: function (e) {
      if (e && e.node) {
        let t = e.node.querySelector(".shipping-cart-bar");
        t &&
          (t.classList.add("opacity-0", "transition-opacity"),
            setTimeout(() => {
              t.remove();
            }, 500));
      }
    },
    renderEmptyCart: function (e, t) {
      if (!t) return;
      var i = ".js-cart-content";
      let n = this.getSectionInnerHTML(e.sections[t.sectionId], i);
      if (n) {
        let r = t.node.querySelector(i);
        r && (r.innerHTML = n);
      }
      let o = t.node.querySelector(".cart-drawer__footer");
      o && (o.innerHTML = "");
    },
    getSectionsToRender: function () {
      var e;
      return [
        {
          id: "#main-cart-page",
          node: document.querySelector("#main-cart-page"),
          sectionId: (e = document.querySelector("#main-cart-page"))
            ? e.dataset.sectionId
            : null,
          itemsContainer: document.querySelector(
            "#main-cart-page .cart__items-container"
          ),
          elementContained: ["item"],
        },
        {
          id: "#cartDrawer",
          node: document.querySelector("#cartDrawer"),
          sectionId: "cart-drawer",
          itemsContainer: document.querySelector(
            "#cartDrawer .cart__items-container"
          ),
          elementContained: ["item", "footer"],
        },
      ].filter((e) => null !== e.node);
    },
    getSectionInnerHTML: function (e, t) {
      if (
        (e = new DOMParser().parseFromString(e, "text/html").querySelector(t))
      )
        return e.innerHTML;
      location.reload();
    },
    handleTermAgreement: function (e) {
      let t = e.querySelector(".js-term-agreement"),
        i = e.querySelector("#checkout");
      t &&
        i &&
        t.addEventListener("click", function () {
          t.checked
            ? "true" === i.dataset.cartEmpty
              ? (i.disabled = !0)
              : (i.disabled = !1)
            : (i.disabled = !0);
        });
    },
  }),
  (theme.cart.mainPage = {
    mainCart: document.querySelector(".main-cart"),
    cartItems: document.getElementById("main-cart-items"),
    render: function () {
      if (this.mainCart && this.cartItems) {
        this.mainCart.querySelectorAll(".cart-item").forEach((e) => {
          theme.cart.setItemEventListener(e);
        });
        var e = this.mainCart.querySelector("form");
        e && theme.cart.handleTermAgreement(e);
      }
    },
  }),
  (theme.cart.inputQuantity = function (e) {
    if (e) {
      let t = Object.create(theme.product.quantityInput);
      (t.wrapper = e), t.render();
    }
  }),
  (theme.cartUpsell = {
    container: null,
    swiper: null,
    render: function () {
      if (!this.container) return;

      const productsContainer = this.container.querySelector('.cart-upsell-products');

      if (productsContainer) {
        this.swiper = new Swiper(productsContainer, {
          slidesPerView: 1.3,
          spaceBetween: 16,
          loop: false,
          navigation: {
            nextEl: this.container.querySelector('.swiper-button-next'),
            prevEl: this.container.querySelector('.swiper-button-prev'),
          },
          on: {
            afterInit: function () {
              theme.utilities.applyAnimation();
            }
          }
        });
      }

      this.container
        .querySelectorAll('form[data-type="add-to-cart-form"]:not([data-upsell-form-initialized])')
        .forEach((form) => {
          form.setAttribute('data-upsell-form-initialized', 'true');

          let upsellForm = Object.create(theme.product.form);
          upsellForm.form = form;
          upsellForm.render();
        });
    }
  }),

  (theme.shipping = {
    init: function () {
      window.generateShippingRates = this.calculateShippingRates.bind(this);
      this.checkShippingCalculator();
    },
    checkShippingCalculator: function () {
      const wrapper = document.querySelector('#cart-shipping-rates-collapse');
    },

    calculateShippingRates: async function (btn) {
      if (!btn) {
        console.error('Botão não fornecido para calculateShippingRates');
        return;
      }

      const wrapper = btn.closest('#cart-shipping-rates-collapse') || document.querySelector('#cart-shipping-rates-collapse');

      if (!wrapper) {
        console.log('Calculador de frete não encontrado - funcionalidade desabilitada');
        return;
      }

      const zipInput = wrapper.querySelector('#shipping-rates-modal-zip');
      if (!zipInput) {
        console.log('Input de CEP não encontrado - funcionalidade desabilitada');
        return;
      }

      const originalText = btn.textContent;
      const originalDisabled = btn.disabled;

      btn.disabled = true;
      btn.classList.add('with-loader--show');

      const spinner = btn.querySelector('.spinner');
      if (spinner) {
        spinner.classList.add('animating');
      }

      const btnContent = btn.querySelector('.btn-content');
      if (btnContent) {
        btn.dataset.originalText = btnContent.textContent;
        btnContent.textContent = 'Calculando...';
      }

      const zip = zipInput.value;

      const dangerElement = wrapper.querySelector('#frete-danger');
      const avisoElement = wrapper.querySelector('#frete-aviso');
      const sucessoElement = wrapper.querySelector('#frete-sucesso');

      if (dangerElement) {
        dangerElement.innerHTML = '';
        dangerElement.setAttribute('hidden', 'hidden');
      }
      if (avisoElement) {
        avisoElement.innerHTML = '';
        avisoElement.setAttribute('hidden', 'hidden');
      }
      if (sucessoElement) {
        sucessoElement.innerHTML = '';
        sucessoElement.setAttribute('hidden', 'hidden');
      }

      const cepUnmasked = zip.replace(/\D/g, '');
      const cepRegex = /^[0-9]{8}$/;

      if (!cepRegex.test(cepUnmasked)) {
        const avisoElement = wrapper.querySelector('#frete-aviso');
        if (avisoElement) {
          avisoElement.innerHTML = `<p class="mb-0">Formato de CEP Inválido.</p>`;
          avisoElement.removeAttribute('hidden');
        }
        this.resetButton(btn);
        return;
      }

      try {
        const isCartDrawer = this.isCartDrawer(btn);
        
        
        if (isCartDrawer) {
          await this.tryCalculateShippingRates(wrapper, cepUnmasked);
        } else {
          await this.calculateProductShipping(wrapper, cepUnmasked);
        }
      } catch (error) {
        console.error('Erro:', error);
      }

      this.resetButton(btn);
    },

    isCartDrawer: function (btn) {
      return btn.closest('.cart-drawer') || btn.closest('#cart-drawer') || btn.closest('[data-cart-drawer]');
    },

    calculateProductShipping: async function (wrapper, cepUnmasked) {
      
      const country = 'BR';
      const brasilApiUrl = `https://brasilapi.com.br/api/cep/v1/${cepUnmasked}`;

      let data;
      try {
        const response = await fetch(brasilApiUrl);
        if (response.ok) {
          data = await response.json();
        } else {
          throw new Error('Erro ao buscar CEP na BrasilAPI');
        }
      } catch (error) {
        const avisoElement = wrapper.querySelector('#frete-aviso');
        if (avisoElement) {
          avisoElement.innerHTML = `<p class="mb-0">CEP não encontrado.</p>`;
          avisoElement.removeAttribute('hidden');
        }
        return;
      }

      const formattedLocation = this.formatLocation(data);
      const sucessoElement = wrapper.querySelector('#frete-sucesso');
      if (sucessoElement) {
        sucessoElement.innerHTML = `<p class="mb-1 small-text"><strong>${formattedLocation}</strong></p>`;
      }

      const province = data.state;

      const cartResponse = await fetch('/cart.js', { method: 'GET' });
      const cartData = await cartResponse.json();
      const originalItems = cartData.items || [];
      const hasItems = originalItems.length > 0;
      

      if (hasItems) {
        const backupCart = originalItems.map((item) => ({
          id: item.variant_id,
          quantity: item.quantity,
        }));
        
        
        await fetch('/cart/clear.js', { method: 'POST' });
        
        await this.addTemporaryProduct();
        
        await this.fetchShippingRates(cepUnmasked, country, province, wrapper);
        
        await fetch('/cart/clear.js', { method: 'POST' });
        
        for (const item of backupCart) {
          await fetch('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({ id: item.id, quantity: item.quantity }),
            headers: {
              'Content-Type': 'application/json',
            },
          });
        }
      } else {
        await this.addTemporaryProduct();
        
        await this.fetchShippingRates(cepUnmasked, country, province, wrapper);
        
        await fetch('/cart/clear.js', { method: 'POST' });
      }
    },

    addTemporaryProduct: async function () {
      
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      const quantInput = document.querySelector('.product-detail .product-quantity__input');

      let quantidade = 1;

      if (variantId && quantInput) {
        quantidade = parseInt(quantInput.value) || 1;
      }


      if (variantId) {
        await fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ id: variantId, quantity: quantidade }),
          headers: { 'Content-Type': 'application/json' },
        });
      } else {
        const productHandle = window.location.pathname.split('/').pop();
        
        const productResponse = await fetch(`/products/${productHandle}.js`);
        const productData = await productResponse.json();

        if (productData.variants && productData.variants.length > 0) {
          const firstVariantId = productData.variants[0].id;
          await fetch('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({ id: firstVariantId, quantity: quantidade }),
            headers: { 'Content-Type': 'application/json' },
          });
        } else {
          console.error('❌ Nenhuma variante encontrada para o produto.');
        }
      }
    },



    resetButton: function (btn) {
      if (!btn) return;

      btn.disabled = false;
      btn.classList.remove('with-loader--show');
      
      const spinner = btn.querySelector('.spinner');
      if (spinner) {
        spinner.classList.remove('animating');
      }
      
      const btnContent = btn.querySelector('.btn-content');
      if (btnContent) {
        btnContent.textContent = btn.dataset.originalText || btn.dataset.text || 'Calcular';
      }
    },

        tryCalculateShippingRates: async function (wrapper, cepUnmasked) {
      
      if (!wrapper) {
        return;
      }
      
      const country = 'BR';
      const brasilApiUrl = `https://brasilapi.com.br/api/cep/v1/${cepUnmasked}`;

      let data;
      try {
        const response = await fetch(brasilApiUrl);
        if (response.ok) {
          data = await response.json();
        } else {
          throw new Error('Erro ao buscar CEP na BrasilAPI');
        }
      } catch (error) {
        const avisoElement = wrapper.querySelector('#frete-aviso');
        if (avisoElement) {
          avisoElement.innerHTML = `<p class="mb-0">CEP não encontrado.</p>`;
          avisoElement.removeAttribute('hidden');
        }
        return;
      }

      const formattedLocation = this.formatLocation(data);
      const sucessoElement = wrapper.querySelector('#frete-sucesso');
      if (sucessoElement) {
        sucessoElement.innerHTML = `<p class="mb-1 small-text"><strong>${formattedLocation}</strong></p>`;
      }

      const province = data.state;

      await this.fetchShippingRates(cepUnmasked, country, province, wrapper);
    },

        fetchShippingRates: async function (cepUnmasked, country, province, wrapper) {
      
      if (!wrapper) {
        return;
      }
      
      const ratesUrl = `/cart/shipping_rates.json?shipping_address[zip]=${cepUnmasked}&shipping_address[country]=${country}&shipping_address[province]=${province}`;

      const ratesResponse = await fetch(ratesUrl, { method: 'GET' });
      const ratesData = await ratesResponse.json();
      
      console.log('📦 Resposta do frete:', ratesData);

      if (ratesResponse.ok && ratesData.shipping_rates.length > 0) {
        console.log('✅ Opções de frete encontradas:', ratesData.shipping_rates.length);
        let ratesHtml = '';
        ratesData.shipping_rates.forEach((rate) => {
          const formattedPrice = rate.price === 0 ? 'Grátis' : this.formatCurrency(rate.price);
          const deliveryDays =
            rate.delivery_days && rate.delivery_days.length > 0 ? this.formatDeliveryDays(rate.delivery_days) : '';
          ratesHtml += `<div><strong>- ${rate.name}</strong>: ${formattedPrice} ${deliveryDays}</div>`;
          console.log('🚚 Opção:', rate.name, '-', formattedPrice, deliveryDays);
        });
        
        const sucessoElement = wrapper.querySelector('#frete-sucesso');
        if (sucessoElement) {
          sucessoElement.innerHTML += ratesHtml;
          sucessoElement.removeAttribute('hidden');
          console.log('✅ Resultado exibido com sucesso');
        }
      } else {
        console.log('❌ Nenhuma opção de frete encontrada');
        const avisoElement = wrapper.querySelector('#frete-aviso');
        if (avisoElement) {
          avisoElement.innerHTML = `<p class="mb-0">Não foi possível encontrar opções de frete para o CEP informado.</p>`;
          avisoElement.removeAttribute('hidden');
        }
      }
    },

    formatLocation: function (data) {
      return `${data.city || data.localidade} - ${data.neighborhood || data.bairro || ''} - ${data.street || data.logradouro || ''}`;
    },

    formatDeliveryDays: function (deliveryDays) {
      const lastDay = deliveryDays[deliveryDays.length - 1];
      return lastDay === 1 ? '- 1 dia útil' : `- ${lastDay} dias úteis`;
    },

    formatCurrency: function (value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    },

    initZipMask: function (container) {
      const zipInput = container.querySelector('#shipping-rates-modal-zip');
      if (zipInput) {
        zipInput.addEventListener('input', function (e) {
          const value = e.target.value.replace(/\D/g, '');
          e.target.value = value.length > 5 ? `${value.slice(0, 5)}-${value.slice(5, 8)}` : value;
        });
      }
    }
  }),
  (theme.cart.drawer = {
    sectionId: "cart-drawer",
    container: null,
    toggle: null,
    render: function () {
      this.toggle &&
        this.toggle.addEventListener(
          "click",
          this.handleToggleOnClick.bind(this)
        );
    },
    showItems: function () {
      setTimeout(() => {
        this.container &&
          this.container.querySelectorAll(".cart-item").forEach((e) => {
            e.classList.remove("opacity-0");
          });
      }, 300);
    },
    handleToggleOnClick: function (e) {
      e.preventDefault(), this.openDrawer();
    },
    openDrawer: function () {
      let e = "?section_id=" + this.sectionId,
        t = this;
      fetch(e)
        .then((e) => e.text())
        .then((e) => {
          if (
            ((this.drawer = document.querySelector("#ajaxDrawer")),
              !this.drawer ||
              ((this.drawer.innerHTML = e),
                this.drawer.classList.remove("d-none"),
                (this.container = this.drawer.querySelector("#cartDrawer")),
                !this.container))
          )
            return;
          let i = this.drawer.querySelector(".ajax-drawer__overlay");
          i &&
            setTimeout(() => {
              i.classList.remove("opacity-0"),
                t.container.classList.add("translate-right-center"),
                t.container
                  .querySelector(".cart-drawer__items")
                  .classList.remove("opacity-0");
            }, 300),
            t.showItems();
          t.container.classList.add("activated"),
            theme.cart.calculateTotalItem(t.container),
            t.container.querySelectorAll(".cart-item").forEach((e) => {
              theme.cart.setItemEventListener(e);
            });

          const cartUpsellSection = t.container.querySelector('.cart-upsell-section');
          if (cartUpsellSection) {
            let cartUpsell = Object.create(theme.cartUpsell);
            cartUpsell.container = cartUpsellSection;
            cartUpsell.render();
          }

          const freteDinamicoSection = t.container.querySelector('#cart-shipping-rates');
          if (freteDinamicoSection) {
            setTimeout(() => {
              theme.shipping.initZipMask(t.container);

              const accordionElement = t.container.querySelector('.accordion');
              if (accordionElement) {
                let accordion = Object.create(theme.component.accordion);
                accordion.element = accordionElement;
                accordion.render();
              }
            }, 100);
          }

          let n = document.querySelectorAll("#ajaxDrawerClose");
          n.length > 0 &&
            n.forEach((e) => {
              e.addEventListener("click", t.closeDrawer.bind(t));
            }),
            document.querySelector("body").classList.add("noscroll"),
            theme.component.renderTooltip(t.container);
          let r = t.container.querySelector("form");
          r && theme.cart.handleTermAgreement(r);
        })
        .catch((e) => console.error("Erro ao abrir o drawer:", e));
    },
    reloadCart: function () {
      let url = `?section_id=${this.sectionId}`;
      let self = this;
      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          let parser = new DOMParser();
          let html = parser.parseFromString(data, "text/html");
          let newContent = html.querySelector("#cartDrawer");

          if (newContent) {
            let currentDrawer = document.querySelector("#cartDrawer");

            if (currentDrawer) {
              currentDrawer.innerHTML = newContent.innerHTML;
              self.container = currentDrawer;

              theme.cart.calculateTotalItem(self.container);
              self.container.querySelectorAll(".cart-item").forEach((item) => {
                theme.cart.setItemEventListener(item);
              });

              const cartUpsellSection = self.container.querySelector('.cart-upsell-section');
              if (cartUpsellSection) {
                let cartUpsell = Object.create(theme.cartUpsell);
                cartUpsell.container = cartUpsellSection;
                cartUpsell.render();
              }

              const freteDinamicoSection = self.container.querySelector('#cart-shipping-rates');
              if (freteDinamicoSection) {
                setTimeout(() => {
                  theme.shipping.initZipMask(self.container);

                  const accordionElement = self.container.querySelector('.accordion');
                  if (accordionElement) {
                    let accordion = Object.create(theme.component.accordion);
                    accordion.element = accordionElement;
                    accordion.render();
                  }
                }, 100);
              }

              self.container.classList.add("translate-right-center");
              self.container.classList.add("activated");

              let closeButtons = document.querySelectorAll("#ajaxDrawerClose");
              closeButtons.forEach((btn) => {
                btn.addEventListener("click", self.closeDrawer.bind(self));
              });
            }
          } else {
            console.error("Erro: Novo conteúdo do cartDrawer não encontrado.");
          }
        })
        .catch((error) => console.error("Erro ao recarregar o drawer:", error));
    },
    closeDrawer: function (e) {
      e.preventDefault();
      let t = e.currentTarget.closest("#ajaxDrawer"),
        i = t.querySelector(".ajax-drawer__overlay");
      i && i.classList.add("opacity-0"),
        this.container &&
        (this.container.classList.remove("translate-right-center"),
          this.container.classList.remove("activated")),
        setTimeout(() => {
          t.classList.add("d-none");
        }, 600),
        document.querySelector("body").classList.remove("noscroll");
    },
  }),
  (theme.navigation = {
    container: document,
    render: function () {
      this.setMenuStyle1(),
        this.container
          .querySelectorAll(".mobile-navigation")
          .forEach(function (e) {
            let t = Object.create(theme.navigation.mobile);
            (t.mobileNav = e), t.render();
          });
    },
    setMenuStyle1: function () {
      let e = this.container.querySelectorAll(".menu-layout-1");
      0 !== e.length &&
        e.forEach(function (e) {
          var t = e.dataset.blockId;
          e.querySelector(
            ".js-featured-product-swiper:not(.swiper-initialized)"
          ) &&
            new Swiper(`[data-block-id="${t}"] .js-featured-product-swiper`, {
              slidesPerView: 3,
              spaceBetween: 10,
              navigation: {
                nextEl: `[data-block-id="${t}"] .swiper-next`,
                prevEl: `[data-block-id="${t}"] .swiper-prev`,
              },
            });
        });
    },
  }),
  (theme.navigation.mobile = {
    mobileNav: null,
    render: function () {
      if (this.mobileNav) {
        let e = document.querySelectorAll(".mobile-navigation__toggle"),
          t = this.mobileNav.querySelector(".mobile-navigation__drawer"),
          i = this.mobileNav.querySelector(".mobile-navigation__overlay"),
          n = this.mobileNav.querySelector(".btn-back"),
          r = this;
        if (!t || !i || !n) return;
        e.forEach((e) => {
          e &&
            e.addEventListener("click", function () {
              t.classList.add("translate-left-center"),
                document
                  .querySelector("main")
                  .classList.add("mobile-navigation-show"),
                document.querySelector("body").classList.add("noscroll"),
                i.classList.remove("d-none"),
                setTimeout(() => {
                  i.classList.remove("opacity-0");
                }, 200);
            });
        });
        let o = this.mobileNav.querySelector("#navigationDrawerClose");
        o &&
          o.addEventListener("click", function () {
            t.classList.remove("translate-left-center"),
              i.classList.add("opacity-0"),
              setTimeout(() => {
                i.classList.add("d-none"),
                  document
                    .querySelector("main")
                    .classList.remove("mobile-navigation-show");
              }, 500),
              document.querySelector("body").classList.remove("noscroll");
          }),
          i &&
          i.addEventListener("click", function () {
            t.classList.remove("translate-left-center"),
              i.classList.add("opacity-0"),
              setTimeout(() => {
                i.classList.add("d-none"),
                  document
                    .querySelector("main")
                    .classList.remove("mobile-navigation-show");
              }, 500),
              document.querySelector("body").classList.remove("noscroll");
          });
        let s = this.mobileNav.querySelectorAll(".menu-level-1");
        s &&
          s.forEach(function (e) {
            e.addEventListener("click", function (e) {
              let t = e.currentTarget
                .closest("li")
                .querySelector(".mobile-navigation__level-2");
              t &&
                (e.preventDefault(),
                  (r.mobileNav.querySelector(
                    ".mobile-navigation__title"
                  ).innerHTML = e.currentTarget.querySelector("span").innerHTML),
                  t.classList.add("translate-left-center"),
                  n.classList.remove("opacity-0"));
            });
          }),
          n &&
          n.addEventListener("click", function () {
            let e = r.mobileNav.querySelector(
              ".mobile-navigation__level-2.translate-left-center"
            );
            e &&
              (e.classList.remove("translate-left-center"),
                n.classList.add("opacity-0"),
                (r.mobileNav.querySelector(
                  ".mobile-navigation__title"
                ).innerHTML = r.mobileNav.querySelector(
                  ".mobile-navigation__title"
                ).dataset.title));
          });
      }
    },
  }),
  (theme.search = {
    render: function () {
      this.headerSearch(), this.mainSearchPage();
    },
    headerSearch: function () {
      let e = document.querySelectorAll(".header-search-open"),
        t = document.querySelector(".header-search"),
        i = document.getElementById("headerSearchClose");
      if (0 !== e.length && t) {
        e.forEach(function (e) {
          e.addEventListener("click", function (e) {
            e.preventDefault(),
              e.stopPropagation(),
              t.classList.add("header-search--show"),
              document.body.classList.add("noscroll"),
              setTimeout(function () {
                t.querySelector(".search-form__input").focus();
              }, 300);
          });
        }),
          i.addEventListener("click", function () {
            t.classList.remove("header-search--show"),
              (t.querySelector(".search-form__input").value = ""),
              document.body.classList.remove("noscroll");
          });
        let n = Object.create(theme.search.form);
        (n.container = t), n.render();

        t.addEventListener('click', function (e) {
          if (e.target === t) {
            t.classList.remove("header-search--show");
            t.querySelector(".search-form__input").value = "";
            document.body.classList.remove("noscroll");
          }
        });
      }
    },
    mainSearchPage: function () {
      var e = document.querySelector(".main-search");
      if (e) {
        let t = Object.create(this.form);
        (t.container = e), (t.hideSearchResultOnFocusOut = !0), t.render();
      }
    },
  }),
  (theme.search.form = {
    container: document.querySelector(".header-search"),
    searchTerm: "",
    sectionId: "search-result",
    hideSearchResultOnFocusOut: !1,
    render: function () {
      (this.searchInput = this.container.querySelector(".search-form__input")),
        (this.searchResult = this.container.querySelector(".search-results")),
        (this.searchForm = this.container.querySelector(".search-form")),
        this.searchInput.addEventListener(
          "input",
          theme.utilities.debounce(this.handleInputOnChange.bind(this), 300)
        ),
        this.searchInput.addEventListener("focus", this.inputFocus.bind(this)),
        this.searchInput.addEventListener(
          "focusout",
          this.inputFocusOut.bind(this)
        );
    },
    handleInputOnChange: function () {
      (this.searchTerm = this.searchInput.value),
        this.searchTerm.length && this.getSearchResults();
    },
    getSearchResults: function () {
      let e = this;
      fetch(
        "/search/suggest?q=" +
        this.searchTerm +
        "&resources[type]=product&section_id=" +
        this.sectionId
      )
        .then((e) => e.text())
        .then((t) => {
          (e.searchResult.innerHTML = t),
            theme.utilities.applyImagesSrcset(),
            theme.utilities.applyAnimation();
        });
    },
    inputFocusOut: function () {
      let e = this;
      this.hideSearchResultOnFocusOut &&
        setTimeout(() => {
          e.searchResult.classList.add("search-results--hide");
        });
    },
    inputFocus: function () {
      let e = this;
      this.hideSearchResultOnFocusOut &&
        setTimeout(() => {
          e.searchResult.classList.remove("search-results--hide");
        });
    },
  }),
  (theme.collectionPage = {
    container: document.querySelector(".collection"),
    productList: document.querySelector(".collection__product-list"),
    productGrid: document.getElementById("product-grid"),
    render: function () {
      if (this.productList) {
        theme.filter.render(), theme.sorting.render(), this.setMobileSidebar();
        let e = Object.create(this.viewMode);
        (e.collectionViewContainer =
          this.container.querySelector(".collection__views")),
          (e.productList = this.productList),
          (e.productGrid = this.productGrid),
          e.setActiveViewMode(),
          e.addEventToModeButton(),
          window.addEventListener(
            "popstate",
            this.handlePopstateEvent.bind(this)
          );
      }
    },
    setAccordion: function () {
      let e = document.querySelectorAll(".collection__filter .accordion");
      0 !== e.length &&
        e.forEach(function (e) {
          let t = Object.create(theme.component.accordion);
          (t.element = e), t.render();
        });
    },
    setMobileSidebar: function () {
      let e = document.querySelector(".collection__sidebar");
      if (e) {
        let t = document.querySelector("#collectionFilterToggle"),
          i = document.querySelector(".collection__sidebar-mobile-overlay");
        (t.addEventListener("click", function () {
          e.classList.add("translate-x-0"),
            document.querySelector(".collection").classList.add("sidebar-open"),
            i.classList.add("d-block"),
            setTimeout(() => {
              i.classList.add("opacity-1");
            }, 100);
        }),
          document.getElementById("CloseCollectionSidebar")).addEventListener(
            "click",
            function () {
              e.classList.remove("translate-x-0"),
                document
                  .querySelector(".collection")
                  .classList.remove("sidebar-open"),
                i.classList.remove("opacity-1"),
                setTimeout(() => {
                  i.classList.remove("d-block");
                }, 1e3);
            }
          );
      }
    },
    handlePopstateEvent: function (e) {
      var t = document.getElementById("product-grid").dataset.id;
      (e = e.state ? e.state.params : ""),
        (t = window.location.pathname + `?section_id=${t}&` + e),
        theme.filter.getProductList(t);
    },
  }),
  (theme.collectionPage.viewMode = {
    collectionViewContainer: document.querySelector(".collection__views"),
    productList: document.querySelector(".collection__product-list"),
    productGrid: document.getElementById("product-grid"),
    setActiveViewMode: function () {
      if (this.productList) {
        let e = window.localStorage.getItem(theme.storageKeys.productGridViews);
        if (null === e || 1 > parseInt(e) || 4 < parseInt(e)) {
          let n = this.collectionViewContainer || document.querySelector(".collection__views");
          let r = window.matchMedia("(min-width: 768px)").matches;
          let o = "4";
          if (n) {
            o = r ? (n.dataset.defaultDesktop || "4") : (n.dataset.defaultMobile || "2");
          } else {
            o = r ? "4" : "2";
          }
          window.localStorage.setItem(theme.storageKeys.productGridViews, o), (e = o);
        }
        let t = this,
          i = ["row-cols"];
        switch (
        ((Array.from(this.productList.classList).forEach(function (e) {
          RegExp(i.join("|")).test(e) && t.productList.classList.remove(e);
        }),
          document.querySelector(
            `.collection__views button[data-column="${e}"]`
          )).classList.add("active"),
          e)
        ) {
          case "1":
            this.productList.classList.add("row-cols-1");
            break;
          case "2":
            this.productList.classList.add("row-cols-2");
            break;
          case "3":
            this.productList.classList.add("row-cols-2", "row-cols-md-3");
            break;
          default:
            this.productList.classList.add("row-cols-2", "row-cols-md-4");
        }
        this.productList.classList.remove("opacity-0"),
          this.productGrid.classList.contains("d-none") &&
          setTimeout(function () {
            this.productGrid.classList.remove("d-none");
          }, 500);
      }
    },
    addEventToModeButton: function () {
      let e = this;
      this.collectionViewContainer &&
        this.collectionViewContainer
          .querySelectorAll("button")
          .forEach(function (t) {
            t.addEventListener("click", e.handleOnClick.bind(e));
          });
    },
    handleOnClick: function (e) {
      this.collectionViewContainer
        .querySelector("button.active")
        .classList.remove("active"),
        e.currentTarget.classList.toggle(
          "active",
          !e.currentTarget.classList.contains("active")
        ),
        (e = e.currentTarget.dataset.column),
        window.localStorage.setItem(theme.storageKeys.productGridViews, e),
        this.setActiveViewMode();
    },
  }),
  (theme.filter = {
    filterForm: document.getElementById("FilterForm"),
    sortingForm: document.getElementById("SortingForm"),
    productGrid: document.getElementById("product-grid"),
    selectors: {
      productContainer: "ProductGridContainer",
      productGrid: "product-grid",
      filters: "ProductFilters",
      filtersMobile: "ProductFiltersMobile",
      filterTags: "filterByTag",
      activeTags: "CollectionActiveTags",
    },
    productGridContainer: document.getElementById("ProductGridContainer"),
    render: function () {
      this.filterForm &&
        (this.filterForm.addEventListener(
          "change",
          this.handleFormChange.bind(this)
        ),
          this.priceRange.init(),
          this.renderActiveFilters(),
          this.renderSwatchFilter());
    },
    handleFormChange: function (e) {
      e.preventDefault(),
        (e = this.getSearchParams()),
        this.updateURL(e),
        this.getProductList(theme.utilities.getSectionUrl(e));
    },
    getSearchParams: function () {
      var e,
        t,
        i = document.getElementById("FilterForm");
      i && "FORM" === i.tagName
        ? (e = new FormData(i))
        : (console.error(
          "O formul\xe1rio 'FilterForm' n\xe3o foi encontrado ou n\xe3o \xe9 um formul\xe1rio."
        ),
          (e = new FormData()));
      var n = document.getElementById("SortingForm");
      return (
        n && "FORM" === n.tagName
          ? (t = new FormData(n))
          : (console.error(
            "O formul\xe1rio 'SortingForm' n\xe3o foi encontrado ou n\xe3o \xe9 um formul\xe1rio."
          ),
            (t = new FormData())),
        new URLSearchParams(e).toString() +
        "&" +
        new URLSearchParams(t).toString()
      );
    },
    getProductList: function (e) {
      let t = this;
      this.productGrid.classList.remove("finished"),
        this.productGrid.classList.add("loading"),
        fetch(e)
          .then((e) => e.text())
          .then((e) => {
            this.productGrid.classList.add("loaded"),
              this.productGrid.classList.remove("loading"),
              this.renderProductGrid(e),
              this.renderProductFilters(e),
              setTimeout(function () {
                t.productGrid.classList.add("finished"),
                  t.productGrid.classList.remove("loaded");
              }, 300);
          });
    },
    renderProductGrid: function (e) {
      let t = new DOMParser().parseFromString(e, "text/html"),
        i = this.productGrid.className;
      e = window.localStorage.getItem(theme.storageKeys.productGridViews);
      let n = t.querySelector(".collection__product-list");
      n &&
        (n.classList.remove("row-cols-4"),
          n.classList.add("row-cols-" + e),
          (this.productGridContainer.innerHTML = t.getElementById(
            this.selectors.productContainer
          ).innerHTML),
          window.scrollTo({
            top: this.productGridContainer.offsetTop - 100,
            behavior: "smooth",
          }),
          (this.productGrid = document.getElementById(
            this.selectors.productGrid
          )),
          (this.productGrid.className = i),
          theme.utilities.imagesSrcset(
            this.productGrid.getElementsByClassName("pr-image")
          ),
          theme.utilities.applyAnimation(),
          theme.product.init(),
          this.renderProductViewMode(),
          this.renderProductSorting(this.productGridContainer));
    },
    renderProductViewMode: function () {
      let e = theme.collectionPage.viewMode;
      (e.container = document.querySelector(".collection__views")),
        (e.productList = document.querySelector(".collection__product-list")),
        (e.productGrid = document.getElementById("product-grid")),
        e.setActiveViewMode(),
        e.addEventToModeButton();
    },
    renderProductFilters: function (e) {
      (e = new DOMParser().parseFromString(e, "text/html")),
        (document.getElementById(this.selectors.filters).innerHTML =
          e.getElementById(this.selectors.filters).innerHTML),
        (document.getElementById(this.selectors.activeTags).innerHTML =
          e.getElementById(this.selectors.activeTags).innerHTML),
        theme.collectionPage.setAccordion(),
        theme.collectionPage.setMobileSidebar(),
        this.renderPriceRange(),
        (this.filterForm = document.getElementById("FilterForm")),
        this.filterForm.addEventListener(
          "change",
          this.handleFormChange.bind(this)
        ),
        this.renderActiveFilters(),
        this.renderSwatchFilter(),
        theme.component.renderTooltip(document);
    },
    renderProductSorting: function (e) {
      let t = theme.form.customSelect,
        i =
          ((t.selectEl = e.querySelectorAll(".custom-select")),
            t.render(),
            Object.create(theme.sorting));
      (i.sortingForm = e.querySelector("#SortingForm")), i.render();
    },
    renderPriceRange: function () {
      let e = Object.create(this.priceRange);
      (e.min = {
        control: document.querySelector(".price-bar__control--min"),
        input: document.querySelector(".filter-price__input--min"),
      }),
        (e.max = {
          control: document.querySelector(".price-bar__control--max"),
          input: document.querySelector(".filter-price__input--max"),
        }),
        (e.bar = document.querySelector(".price-bar")),
        (e.activeBar = document.querySelector(".price-bar__active")),
        e.init();
    },
    updateURL: function (e) {
      history.pushState({ params: e }, "", window.location.pathname + "?" + e);
    },
    renderActiveFilters: function () {
      let e = Object.create(this.activeFilters);
      (e.appliedFilters = document.querySelectorAll(".applied-filter")),
        e.render();
    },
    renderSwatchFilter: function () {
      let e = document.querySelector(".collection__filter--swatch");
      e &&
        e.querySelectorAll("label").forEach((e) => {
          var t = e.dataset.swatch.toLowerCase();
          (t = theme.product.customSwatchColors()[t]) &&
            (e.style.cssText = "--filter-swatch-color: " + t);
        });
    },
  }),
  (theme.filter.activeFilters = {
    appliedFilters: document.querySelectorAll(".applied-filter"),
    render: function () {
      0 !== this.appliedFilters.length &&
        this.appliedFilters.forEach((e) => {
          e.addEventListener(
            "click",
            this.handleActiveFilterOnClick.bind(this)
          );
        });
    },
    handleActiveFilterOnClick: function (e) {
      e.preventDefault(),
        (e =
          -1 == e.currentTarget.href.indexOf("?")
            ? ""
            : e.currentTarget.href.slice(
              e.currentTarget.href.indexOf("?") + 1
            ));
      var t =
        (theme.filter.updateURL(e),
          document.getElementById("product-grid").dataset.id);
      (t = window.location.pathname + `?section_id=${t}&` + e),
        theme.filter.getProductList(t);
    },
  }),
  (theme.sorting = {
    sortingForm: document.getElementById("SortingForm"),
    render: function () {
      this.sortingForm &&
        this.sortingForm.addEventListener(
          "change",
          this.handleOnChange.bind(this)
        );
    },
    handleOnChange: function (e) {
      e.preventDefault(),
        (e = theme.filter.getSearchParams()),
        theme.filter.updateURL(e),
        theme.filter.getProductList(theme.utilities.getSectionUrl(e));
    },
  }),
  (theme.filter.priceRange = {
    min: {
      control: document.querySelector(".price-bar__control--min"),
      input: document.querySelector(".filter-price__input--min"),
    },
    max: {
      control: document.querySelector(".price-bar__control--max"),
      input: document.querySelector(".filter-price__input--max"),
    },
    bar: document.querySelector(".price-bar"),
    activeBar: document.querySelector(".price-bar__active"),
    offsetX: 0, 

    init: function () {
      this.min.control &&
        ((this.min.value = parseInt(this.min.input.value || this.min.input.placeholder)),
          (this.max.value = parseInt(this.max.input.value || this.max.input.placeholder)),
          (this.minValue = parseInt(this.min.input.getAttribute("min"))),
          (this.maxValue = parseFloat(this.max.input.getAttribute("max")) + 1),
          (this.barWidth = this.bar.offsetWidth),
          (this.ratioWidthMaxValue = this.maxValue / this.barWidth),
          (this.ratioPriceValue = 100 / (this.maxValue - this.minValue)),
          this.setEvents(),
          this.setInputEvents(),
          this.applyControlPosition(this.min),
          this.applyControlPosition(this.max));
    },

    setEvents: function () {
      [this.min.control, this.max.control].forEach((control) => {
        control.addEventListener("mousedown", this.handleMouseDown.bind(this));
        control.addEventListener("touchstart", this.handleTouchStart.bind(this), { passive: false });
      });
    },

    handleMouseDown: function (e) {
      e.preventDefault();
      this.activeSlider = e.currentTarget === this.min.control ? this.min : this.max;
      this.offsetX = e.clientX - this.activeSlider.control.getBoundingClientRect().left;

      this.boundHandleMouseMove = this.handleMouseMove.bind(this);
      this.boundHandleMouseUp = this.handleMouseUp.bind(this);

      window.addEventListener("mousemove", this.boundHandleMouseMove);
      window.addEventListener("mouseup", this.boundHandleMouseUp);
    },

    handleMouseMove: function (e) {
      let mouseX = e.clientX - this.offsetX;
      this.updateSliderPosition(mouseX);
    },

    handleMouseUp: function () {
      window.removeEventListener("mousemove", this.boundHandleMouseMove);
      window.removeEventListener("mouseup", this.boundHandleMouseUp);
      this.triggerInputChange();
    },

    handleTouchStart: function (e) {
      e.preventDefault();
      let touch = e.touches[0];
      this.activeSlider = e.currentTarget === this.min.control ? this.min : this.max;
      this.offsetX = touch.clientX - this.activeSlider.control.getBoundingClientRect().left;

      this.boundHandleTouchMove = this.handleTouchMove.bind(this);
      this.boundHandleTouchEnd = this.handleTouchEnd.bind(this);

      window.addEventListener("touchmove", this.boundHandleTouchMove, { passive: false });
      window.addEventListener("touchend", this.boundHandleTouchEnd);
    },

    handleTouchMove: function (e) {
      e.preventDefault();
      let touchX = e.touches[0].clientX - this.offsetX;
      this.updateSliderPosition(touchX);
    },

    handleTouchEnd: function () {
      window.removeEventListener("touchmove", this.boundHandleTouchMove);
      window.removeEventListener("touchend", this.boundHandleTouchEnd);
      this.triggerInputChange();
    },

    updateSliderPosition: function (posX) {
      let barRect = this.bar.getBoundingClientRect();
      let barLeft = barRect.left;
      let barWidth = barRect.width;

      let t = Math.ceil(((posX - barLeft) / barWidth) * this.maxValue);
      t = Math.max(this.minValue, Math.min(t, this.maxValue));

      if (this.activeSlider === this.min) {
        this.min.input.value = t > this.max.value ? this.max.value : t;
        this.min.value = this.min.input.value;
        this.applyControlPosition(this.min);
      } else {
        this.max.input.value = t < this.min.value ? this.min.value : t;
        this.max.value = this.max.input.value;
        this.applyControlPosition(this.max);
      }
    },

    applyControlPosition: function (e) {
      e.control.style.left = (e.value - this.minValue) * this.ratioPriceValue + "%";
      this.activeBar.style.left = (this.min.value - this.minValue) * this.ratioPriceValue + "%";
      this.setActiveBarWidth();
    },

    setActiveBarWidth: function () {
      this.activeBar.style.width = this.calculateActiveBarWidth() + "%";
    },

    calculateActiveBarWidth: function () {
      return ((this.max.value - this.min.value) / this.maxValue) * 100;
    },

    triggerInputChange: function () {
      [this.min.input, this.max.input].forEach((input) => {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    },

    setInputEvents: function () {
      [this.min.input, this.max.input].forEach((input) => {
        input.addEventListener("change", this.handleInputChange.bind(this));
      });
    },

    handleInputChange: function (e) {
      e.preventDefault();
      let t = parseInt(e.currentTarget.value);
      if (e.currentTarget === this.min.input) {
        this.min.input.value = t > this.max.value ? this.max.value : t;
        this.min.value = this.min.input.value;
        this.applyControlPosition(this.min);
      } else {
        this.max.input.value = t < this.min.value ? this.min.value : t;
        this.max.value = this.max.input.value;
        this.applyControlPosition(this.max);
      }
    },
  }),
  (theme.featuredCollection = {
    container: void 0,
    swiperSelector: void 0,
    render: function () {
      if (this.container) {
        var e = this.container.dataset.sectionId;
        let t = this;
        if (this.container.querySelector(".featured-collection__swiper")) {
          theme.slider.init(this.container);
          let i = this.container.querySelectorAll(
            ".product-card:not([card-rendered])"
          );
          i.forEach((e) => {
            let t = Object.create(theme.product.card);
            (t.item = e), t.render();
          });
        } else {
          let i = this.container.querySelectorAll(
            ".product-card:not([card-rendered])"
          );
          theme.utilities.applyAnimation(),
            i.forEach((e) => {
              let t = Object.create(theme.product.card);
              (t.item = e), t.render();
            });
        }
      }
    },
    renderSlideProductCard: function (e) {
      let t = this.container.dataset.sectionId;
      e.forEach((e) => {
        if (
          e.closest(".featured-collection").dataset.sectionId === t &&
          (e = e.querySelector(".product-card:not([card-rendered])"))
        ) {
          let i = Object.create(theme.product.card);
          (i.item = e), i.render();
        }
      });
    },
  }),
  (theme.featuredProduct = {
    element: null,
    render: function () {
      if (this.element) {
      this.mainProduct = this.element;
        var e = this.element.dataset.sectionId;
        let t;
        if (this.element.querySelector(".product-media__swiper")) {
          let i = Object.create(theme.product.imageSlider);
          (i.sliderSelector = `[data-section-id="${e}"] .product-media__swiper`),
            (i.sliderNavSelector = `[data-section-id="${e}"] .product-media__nav-swiper`),
            (i.productId = this.element.dataset.productId),
            (i.sectionId = this.element.dataset.sectionId),
            (t = i.render()),
            this.setMediaContainerHeight(),
            window.addEventListener(
              "resize",
              this.setMediaContainerHeight.bind(this)
            );
        }
        let n = Object.create(theme.product.form);
        if (
          ((n.form = this.element.querySelector(".product-form")),
            n.render(),
            (e = this.element.querySelector(
              ".product-variant:not(.product-variant--placeholder)"
            )))
        ) {
          let r = Object.create(theme.product.variant);
          (r.productVariant = e),
            t && (r.imageSlider = t),
            (r.form = n),
            r.render();
        }
        let o = this.element.querySelector(".product-detail");
        if ((e = this.element.querySelector(".featured-product__quantity"))) {
          let c = Object.create(theme.product.quantityInput);
          (c.wrapper = e), c.render();
        }
      }
    },
    setMediaContainerHeight: function () {
      let e = this.mainProduct.querySelector(".product-media"),
        t = e.querySelector(".thumbnail-left, .thumbnail-right");
      if (t) {
        let i = e.querySelector(".product-media__swiper");
        if (i) {
          let mediaElement = i.querySelector(".media");
          let stickyElement = e.querySelector(".product-media-sticky");
          let paddingOffset = 0;
          
          if (stickyElement) {
            let computedStyle = window.getComputedStyle(stickyElement);
            let paddingTop = parseFloat(computedStyle.paddingTop) || 0;
            let paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
            paddingOffset = paddingTop + paddingBottom;
          }
          
          t.style.height = (mediaElement.offsetHeight + paddingOffset) + "px";
        }
      }
    },
  }),
  (theme.productRecommendation = {
    container: document.querySelector(".product-recommendations"),
    swiperSelector: void 0,
    render: function () {
      this.container &&
        new IntersectionObserver(this.handleIntersection.bind(this), {
          rootMargin: "0px 0px 200px 0px",
        }).observe(this.container);
    },
    handleIntersection: function (e, t) {
      if (e[0].isIntersecting) {
        t.unobserve(this.container);
        let i = this;
        fetch(this.container.dataset.url)
          .then((e) => e.text())
          .then((e) => {
            let t = document.createElement("div"),
              n =
                ((t.innerHTML = e),
                  t.querySelector(".product-recommendations"));
            n &&
              n.innerHTML.trim().length &&
              ((i.container.innerHTML = n.innerHTML),
                theme.utilities.applyAnimation(),
                theme.utilities.applyImagesSrcset(),
                i.renderProductCard(),
                i.initSliderIfNeeded());
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    initSliderIfNeeded: function () {
      if (this.container.querySelector(".product-recommendations__swiper")) {
        let e = `[data-section-id="${this.container.dataset.sectionId}"] .product-recommendations__swiper`;
        this.renderSlider(e);
      }
    },
    renderSlider: function (e) {
      theme.slider.init(this.container);
    },
    renderProductCard: function () {
      this.container.querySelectorAll(".product-card").forEach(function (e) {
        theme.component.renderTooltip(e);
        let t = Object.create(theme.product.card);
        (t.item = e), t.render();
      });
    },
  }),
  (theme.recentViewedProduct = {
    container: null,
    render: function () {
      this.container && this.getProducts();
    },
    getProducts: function () {
      let e = theme.utilities.getListFromStorage(
        theme.storageKeys.recentViewedProduct
      ),
        t = document.querySelector(".product-detail");
      var i = parseInt(this.container.dataset.maxItem) || 16;
      if (
        0 <
        (e = (e = t ? e.filter((e) => e != t.dataset.productId) : e)
          .toReversed()
          .slice(0, i)).length
      ) {
        i = e.map((e) => "id:" + e).join(" OR ");
        let n = this;
        fetch((i = window.location.origin + "/search?view=product&q=" + i))
          .then((e) => e.text())
          .then((e) => {
            let t = new DOMParser().parseFromString(e, "text/html"),
              r = t
                .querySelector("#searchResult")
                .querySelectorAll(".product-card");

            const gridContainer = n.container.querySelector('.recent-viewed-product__grid');
            const swiperWrapper = n.container.querySelector(".swiper-wrapper");
            
            if (gridContainer) {
              gridContainer.innerHTML = "";
            } else if (swiperWrapper) {
              swiperWrapper.innerHTML = "";
            }

            r.forEach((productCard, index) => {
              let clonedProduct = productCard.cloneNode(true);
              let productForm = clonedProduct.querySelector(".product-form");

              if (productForm) {
                let originalId = productForm.getAttribute("id");
                let newId = originalId + "-" + index;

                productForm.setAttribute("id", newId);

                clonedProduct.querySelectorAll(`input[form="${originalId}"]`).forEach((input) => {
                  input.setAttribute("form", newId);
                });
              }

              if (gridContainer) {
                let col = document.createElement('div');
                col.className = 'col';
                col.appendChild(clonedProduct);
                gridContainer.appendChild(col);
              } else if (swiperWrapper) {
                let slide = document.createElement("div");
                slide.classList.add("swiper-slide");
                slide.appendChild(clonedProduct);
                swiperWrapper.appendChild(slide);
              }
            }),
              theme.utilities.imagesSrcset(
                n.container.getElementsByClassName("pr-image")
              ),
              theme.utilities.applyAnimation(),
              theme.wishlist.setInWishlistProduct(),
              n.renderProductCard(),
              gridContainer ? null : (e = `[data-section-id="${this.container.dataset.sectionId}"] .recent-viewed-product__swiper`, n.renderSlider(e));

          })
          .catch((e) => {
            console.log(e);
          });
      } else this.container.remove();
    },
    renderSlider: function (e) {
      theme.slider.init(this.container);
    },
    renderProductCard: function () {
      this.container.querySelectorAll(".product-card").forEach(function (e) {
        let t = Object.create(theme.product.card);
        (t.item = e), t.render();
      }),
        theme.component.renderTooltip(this.container);
    },
  }),
  (theme.saleNotification = {
    section: null,
    currentCardIndex: 0,
    intervalId: null,
    dismissedCards: new Set(),
    render: function () {
      this.section &&
        ((this.displayTime = 1e3 * this.section.dataset.displayTime),
          (this.delayTime = 1e3 * this.section.dataset.delayTime),
          (this.notificationCards = this.section.querySelectorAll(
            ".sale-notification__card"
          )),
          0 !== this.notificationCards.length &&
          (this.resumeCardActivation(),
            this.notificationCards.forEach((e, t) => {
              e.querySelector(".sale-notification__card-close").addEventListener(
                "click",
                () => {
                  e.classList.remove("sale-notification__card--active"),
                    setTimeout(() => {
                      e.classList.add("d-none");
                    }, 500),
                    this.dismissedCards.add(t),
                    this.checkAllDismissed();
                }
              );
            })));
    },
    setCardActive() {
      let e = this;
      if (this.dismissedCards.size === this.notificationCards.length) {
        clearInterval(this.intervalId);
        return;
      }
      for (; this.dismissedCards.has(this.currentCardIndex);)
        this.currentCardIndex =
          (this.currentCardIndex + 1) % this.notificationCards.length;
      let t = this.currentCardIndex;
      this.notificationCards[t].classList.remove("d-none"),
        setTimeout(() => {
          e.notificationCards[t].classList.add(
            "sale-notification__card--active"
          );
        }, 100),
        clearInterval(this.intervalId),
        setTimeout(function () {
          e.notificationCards[t].classList.remove(
            "sale-notification__card--active"
          ),
            setTimeout(() => {
              e.notificationCards[t].classList.add("d-none");
            }, 500),
            (e.currentCardIndex = (t + 1) % e.notificationCards.length),
            e.resumeCardActivation();
        }, e.displayTime);
    },
    resumeCardActivation: function () {
      let e = this;
      if (this.dismissedCards.size === this.notificationCards.length) {
        clearInterval(this.intervalId);
        return;
      }
      this.intervalId = setInterval(function () {
        e.setCardActive();
      }, e.delayTime);
    },
    checkAllDismissed: function () {
      this.dismissedCards.size === this.notificationCards.length &&
        clearInterval(this.intervalId);
    },
  }),
  (theme.whatsappPopup = {
    section: null,
    render: function () {
      if (!this.section) return;

      this.chatButton = this.section.querySelector('#essence-wpp-whatsapp-chat-btn');
      this.dialog = this.section.querySelector('#essence-wpp-whatsapp-chat-dialog');
      this.userForm = this.section.querySelector('#essence-wpp-whatsapp-chat-dialog-user-form');
      this.userInput = this.section.querySelector('#essence-wpp-whatsapp-chat-dialog-user-input');
      this.whatsappNumber = (this.section.dataset.whatsappNumber || '').split('-').join('');
      this.hasDialog = this.section.dataset.hasDialog === 'true';

      this.bindChatButton();
      this.bindCloseButton();
      this.handleKeyboard();
      this.handleFormSubmit();
    },
    bindChatButton: function () {
      if (!this.chatButton) return;

      this.chatButton.addEventListener('click', () => {
        if (this.hasDialog) {
          this.toggleDialog();
        } else {
          this.openWhatsApp();
        }
      });
    },
    toggleDialog: function () {
      if (!this.dialog) return;

      if (this.dialog.hasAttribute('open')) {
        this.closeDialog();
        return;
      }

      this.openDialog();
    },
    openDialog: function () {
      if (!this.dialog) return;

      this.dialog.setAttribute('open', '');
      this.section.setAttribute('data-dialog-open', 'true');

      setTimeout(() => {
        this.userInput && this.userInput.focus();
      }, 300);

      setTimeout(() => {
        const typing = this.section.querySelector('#essence-wpp-whatsapp-chat-dialog-msg-typing');
        const text = this.section.querySelector('#essence-wpp-whatsapp-chat-dialog-msg-text');
        if (typing) typing.style.display = 'none';
        if (text) text.style.display = 'block';
      }, 2000);

      this.trapFocus();
    },
    closeDialog: function () {
      if (!this.dialog) return;

      this.dialog.removeAttribute('open');
      this.section.setAttribute('data-dialog-open', 'false');
      this.chatButton && this.chatButton.focus();
    },
    openWhatsApp: function () {
      if (!this.chatButton) return;

      this.chatButton.classList.add('loading');
      setTimeout(() => {
        window.open(`https://wa.me/${this.whatsappNumber}`, '_blank');
        this.chatButton.classList.remove('loading');
      }, 1000);
    },
    bindCloseButton: function () {
      const closeButton = this.section.querySelector('#essence-wpp-whatsapp-chat-dialog-close');
      if (!closeButton) return;

      closeButton.addEventListener('click', () => this.closeDialog());
      this.section.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.closeDialog();
      });
    },
    handleKeyboard: function () {
      if (!this.dialog || !this.userInput) return;

      this.userInput.addEventListener('focus', () => {
        this.dialog.setAttribute('data-keyboard-open', '');
      });
      this.userInput.addEventListener('blur', () => {
        this.dialog.removeAttribute('data-keyboard-open');
      });
    },
    handleFormSubmit: function () {
      if (!this.userForm) return;

      this.userForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const submitButton = this.section.querySelector('#essence-wpp-whatsapp-chat-dialog-btn');
        submitButton && submitButton.classList.add('loading');

        setTimeout(() => {
          const text = this.userInput && this.userInput.value
            ? `?text=${encodeURIComponent(this.userInput.value)}`
            : '';
          window.open(`https://wa.me/${this.whatsappNumber}${text}`, '_blank');
          submitButton && submitButton.classList.remove('loading');
        }, 1000);
      });
    },
    trapFocus: function () {
      if (!this.dialog) return;
      const focusableElements = this.dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      const handleTab = (event) => {
        if (event.key !== 'Tab') return;

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      };

      this.dialog.addEventListener('keydown', handleTab);
    },
  }),
  (theme.menuFlutuante = {
    container: null,
    render: function () {
      var e = this.container;
      e &&
        window.addEventListener("scroll", function () {
          (document.documentElement.scrollTop || document.body.scrollTop) > 700
            ? e.classList.remove("translate-y-b-hidden")
            : e.classList.add("translate-y-b-hidden");
        });
    },
  }),
  (theme.slideshow = {
    container: null,
    selector: null,
    swiperInstance: null,
    
    render: function () {
      var e, t, i;
      !this.container ||
        this.container.querySelectorAll(".swiper-slide").length < 2 ||
        ((e = "true" === this.container.dataset.autoplay),
          (t = parseInt(this.container.dataset.autoplaySpeed)),
          (i = this.container.dataset.slideEffect),
          new Swiper(this.selector, {
            spaceBetween: 0,
            loop: !0,
            grabCursor: !0,
            effect: i,
            autoplay: e && { delay: 1e3 * t },
            pagination: !!this.container.querySelector(".swiper-pagination") && {
              el: this.container.querySelector(".swiper-pagination"),
              clickable: !0,
            },
            navigation: !(
              !this.container.querySelector(".swiper-button-next") ||
              !this.container.querySelector(".swiper-button-prev")
            ) && {
              nextEl: this.container.querySelector(".swiper-button-next"),
              prevEl: this.container.querySelector(".swiper-button-prev"),
            },
            on: {
              afterInit: function () {
                theme.utilities.applyAnimation();
              },
              loopFix: function () {
                theme.utilities.applyAnimation();
              },
              slideChange: function (e) {
                e.autoplay && (e.touches.diff || e.clicked) && e.autoplay.stop();
              },
            },
          }));
    },
  }),
  (theme.announcementBar = {
    element: null,
    render: function () {
      if (this.element) {
        const swiperContainer = this.element.querySelector('.swiper-container');

        if (swiperContainer) {
          const nextButton = swiperContainer.querySelector('.swiper-button-next');
          const prevButton = swiperContainer.querySelector('.swiper-button-prev');
          const navigation =
            nextButton && prevButton
              ? { nextEl: nextButton, prevEl: prevButton }
              : false;

          new Swiper(swiperContainer, {
            loop: true,
            grabCursor: true,
            autoplay: {
              delay: this.element.dataset.duration * 1000 || 3000,
              disableOnInteraction: false,
            },
            navigation: navigation,
            slidesPerView: 1
          });
        }
      }
    },
  }),
  (theme.slider = {
    init: function (container, options) {
      if (!container) return null;
      const selector = container.querySelector(".swiper") || ".swiper";
      const swiperEl =
        typeof selector === "string" ? container.querySelector(selector) : selector;
      if (!swiperEl) return null;

      const nextEls = container.querySelectorAll(".swiper-nav-next");
      const prevEls = container.querySelectorAll(".swiper-nav-prev");
      const scrollbarEl = container.querySelectorAll(".swiper-scrollbar");
      
      const navigation =
        nextEls.length > 0 && prevEls.length > 0
          ? {
              nextEl: [...nextEls], 
              prevEl: [...prevEls], 
            }
          : false;

      const slideMobile = parseFloat(container.dataset.slideMobile) || 1;
      const slideDesktop = parseFloat(container.dataset.slideDesktop) || 5;

      const swiper = new Swiper(swiperEl, {
        a11y: !1,
        spaceBetween: 10,
        navigation: navigation,
        scrollbar: scrollbarEl.length > 0 ? { el: scrollbarEl } : false,
        breakpoints: {
          0: { slidesPerView: slideMobile },
          768: { slidesPerView: slideDesktop },
        },
        on: {
          afterInit: function () {
            theme.utilities.applyAnimation();
          },
          loopFix: function () {
            theme.utilities.applyAnimation();
          },
        },
      });

      return swiper;
    },
  }),
  (theme.collectionList = {
    container: null,
    render: function () {
      if (!this.container) return;

      theme.slider.init(this.container);
    },
  }),
  (theme.multicolumn = {
    section: null,
    render: function () {
    if (!this.section) return;

    theme.slider.init(this.section);
    },
  }),
  (theme.productFeatures = {
    container: null,
    render: function () {
      if (!this.container || "true" !== this.container.dataset.carrossel)
        return;
      let e = Number(this.container.dataset.slideMobile) || 1,
        t = "true" === this.container.dataset.slideMobilePartial ? e + 0.3 : e;
      new Swiper(this.container.querySelector(".product-features__swiper"), {
        a11y: !1,
        loop: !0,
        pagination: !!this.container.querySelector(".swiper-pagination") && {
          el: this.container.querySelector(".swiper-pagination"),
          clickable: !0,
        },
        breakpoints: {
          0: { slidesPerView: t },
          570: {
            slidesPerView: Number(this.container.dataset.slideTablet) || 2,
          },
          990: {
            slidesPerView: Number(this.container.dataset.slideDesktop) || 4,
          },
        },
        on: {
          afterInit: function () {
            theme.utilities.applyAnimation();
          },
          loopFix: function () {
            theme.utilities.applyAnimation();
          },
        },
      });
    },
  }),
  (theme.textMarquee = {
    container: null,
    render: function () {
      if (!this.container) return;
    },
  }),
  
  (function() {
    class MarqueeText extends HTMLElement {
      constructor() {
        super();
        if (window.ResizeObserver) {
          new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
        }
      }
  
      _calculateDuration(entries) {
        const speed = parseInt(this.getAttribute("scrolling-speed") || 5);
        const sectionId = this.getAttribute("section-id");
        const content = this.querySelector("span");
        if (!content) return;
        const width = entries[0].contentRect.width;
        const contentWidth = content.clientWidth;
        const slowFactor = 1 + (Math.min(1600, width) - 375) / (1600 - 375) * 2.5;
        const duration = (speed * slowFactor * contentWidth / width).toFixed(3);
        this.style.setProperty("--marquee-animation-duration", `${duration}s`);
      }
    }
  
    if (!window.customElements.get('marquee-text')) {
      window.customElements.define('marquee-text', MarqueeText);
    }
  })();
  (theme.feedInstagram = {
    container: null,
    render: function () {
      if (!this.container) return;
      
      const slideMobile = parseFloat(this.container.dataset.slideMobile) || 2.5;
      const slideDesktop = parseFloat(this.container.dataset.slideDesktop) || 4.5;
      
      this.swiperInstance = new Swiper(
        this.container.querySelector(".feed-instagram__swiper"),
        {
          a11y: !1,
          loop: !0,
          speed: 4e3,
          centeredSlides: !0,
          allowTouchMove: !1,
          breakpoints: {
            0: { slidesPerView: slideMobile, spaceBetween: 12 },
            768: { slidesPerView: slideDesktop, spaceBetween: 20 },
          },
          autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
          },
          on: {
            afterInit: function () {
              theme.utilities.applyAnimation();
            },
            loopFix: function () {
              theme.utilities.applyAnimation();
            },
          },
        }
      );
    },
  }),
  (theme.customer = {
    page: document.querySelector(".customer-page"),
    customerAddressPage: document.querySelector(".customer-address"),
    render: function () {
      this.page && this.customerAddressPage && this.addressPage();
    },
    addressPage: function () {
      let e = this,
        t = this.page.querySelectorAll(".address-item"),
        i =
          (0 < t.length &&
            t.forEach(function (t) {
              t
                .querySelector(".edit-button")
                .addEventListener("click", function () {
                  let e = t.querySelector(".modal-edit");
                  e.classList.remove("d-none"),
                    setTimeout(function () {
                      e.classList.remove("opacity-0"),
                        e
                          .querySelector(".modal-content")
                          .classList.remove("translate-y-hidden"),
                        e
                          .querySelector(".modal-content")
                          .classList.add("translate-0");
                    }, 300);
                }),
                t
                  .querySelector(".modal-close")
                  .addEventListener("click", function () {
                    e.closeModal(t.querySelector(".modal-edit"));
                  }),
                t
                  .querySelector(".btn-delete")
                  .addEventListener("click", function (e) {
                    confirm(e.currentTarget.dataset.confirmMessage) &&
                      theme.Shopify.postLink(e.currentTarget.dataset.target, {
                        parameters: { _method: "delete" },
                      });
                  });
            }),
            this.page.querySelector("#newAddressButton")),
        n = this.page.querySelector(".modal-new"),
        r = n.querySelector(".modal-close"),
        o = n.querySelector("form");
      i.addEventListener("click", function () {
        n.classList.remove("d-none"),
          document.querySelector("body").classList.add("noscroll"),
          setTimeout(function () {
            n.classList.remove("opacity-0"),
              n
                .querySelector(".modal-content")
                .classList.remove("translate-y-hidden"),
              n.querySelector(".modal-content").classList.add("translate-0");
          }, 300);
      }),
        r.addEventListener("click", function (t) {
          e.closeModal(n);
        }),
        o.addEventListener("submit", function (t) {
          e.closeModal(n);
        }),
        this.page
          .querySelectorAll('button[type="reset"]')
          .forEach(function (t) {
            t.addEventListener("click", function () {
              e.closeModal(t.closest(".modal"));
            });
          });
    },
    closeModal: function (e) {
      e.classList.add("fade-out"),
        setTimeout(function () {
          e.classList.add("opacity-0"),
            e.classList.add("d-none"),
            e
              .querySelector(".modal-content")
              .classList.add("translate-y-hidden"),
            e.querySelector(".modal-content").classList.remove("translate-0"),
            document.querySelector("body").classList.remove("noscroll"),
            e.classList.remove("fade-out");
        }, 300);
    },
  }),
  (theme.section = {
    render: function () {
      let announcementBar = document.querySelector(".announcement-bar");
      if (announcementBar) {
        let a = Object.create(theme.announcementBar);
        a.element = announcementBar;
        a.render();
      }

      let e = document.querySelectorAll(".product-recommendations");
      e.length > 0 &&
        e.forEach(function (e) {
          let t = Object.create(theme.productRecommendation);
          (t.container = e), t.render();
        });
      let t = document.querySelectorAll(".featured-collection");
      t.length > 0 &&
        t.forEach(function (e) {
          let t = Object.create(theme.featuredCollection);
          (t.container = e),
            (t.swiperSelector = `[data-section-id="${e.dataset.sectionId}"] .featured-collection__swiper`),
            t.render();
        });
      let i = document.querySelectorAll(".collection-list");
      i.length > 0 &&
        i.forEach(function (e) {
          let t = Object.create(theme.collectionList);
          (t.container = e), t.render();
        });
      let n = document.querySelectorAll(".menu-flutuante");
      n.length > 0 &&
        n.forEach(function (e) {
          let t = Object.create(theme.menuFlutuante);
          (t.container = e), t.render();
        });
      let r = document.querySelectorAll(".product-features");
      r.length > 0 &&
        r.forEach(function (e) {
          let t = Object.create(theme.productFeatures);
          (t.container = e), t.render();
        });
      let textMarquee = document.querySelectorAll(".teamdrop-height-observer");
      textMarquee.length > 0 &&
        textMarquee.forEach(function (e) {
          let t = Object.create(theme.textMarquee);
          (t.container = e), t.render();
        });
      let o = document.querySelectorAll(".feed-instagram");
      o.length > 0 &&
        o.forEach(function (e) {
          let t = Object.create(theme.feedInstagram);
          (t.container = e), t.render();
        });
      let s = document.querySelectorAll(".slideshow-section");
      s.length > 0 &&
        s.forEach(function (e) {
          let t = Object.create(theme.slideshow);
          (t.container = e),
            (t.selector = `#${e.getAttribute(
              "id"
            )} .slideshow-section__swiper`),
            t.render();
        });
      let a = document.querySelectorAll(".featured-product");
      a.length > 0 &&
        a.forEach(function (e) {
          let t = Object.create(theme.featuredProduct);
          (t.element = e), t.render();
        });
      let c = document.querySelectorAll(".multicolumn");
      c.length > 0 &&
        c.forEach((e) => {
          let t = Object.create(theme.multicolumn);
          (t.section = e), t.render();
        });
      let l = document.querySelectorAll(".recent-viewed-product");
      l.length > 0 &&
        l.forEach((e) => {
          let t = Object.create(theme.recentViewedProduct);
          (t.container = e), t.render();
        });
      let d = document.querySelectorAll(".sale-notification");
      d.length > 0 &&
        d.forEach((e) => {
          let t = Object.create(theme.saleNotification);
          (t.section = e), t.render();
        });
      let w = document.querySelectorAll(".whatsapp-popup");
      w.length > 0 &&
        w.forEach((e) => {
          let t = Object.create(theme.whatsappPopup);
          (t.section = e), t.render();
        });
    },
  }),
  document.addEventListener(
    "shopify:section:load",
    theme.events.shopifyEditor.handleSectionLoad
  ),
  theme.utilities.applyAnimation(),
  theme.utilities.applyImagesSrcset(),
  theme.events.onScroll.addEvent(),
  (theme.wishlist = {
    productContainerSelector: [
      ".product-card",
      ".main-product .product-detail",
      ".featured-product",
      ".collage-product",
      ".product-sticky",
    ],
    inWishlistClass: "wishlisted",
    render: function () {
      this.setCounter(),
        this.page(),
        this.setEventListenerToProduct(),
        this.setInWishlistProduct();
    },
    setEventListenerToProduct: function () {
      document.addEventListener("click", this.handleClickEvent.bind(this));
    },
    handleClickEvent: function (e) {
      e.target.closest(".js-add-wishlist")
        ? (e.preventDefault(),
          this.addProduct(
            e.target.closest(".js-add-wishlist").dataset.productId
          ))
        : e.target.closest(".js-remove-wishlist") &&
        (e.preventDefault(),
          this.removeProduct(
            e.target.closest(".js-remove-wishlist").dataset.productId
          ));
    },
    setInWishlistProduct: function () {
      let e = this,
        t = theme.utilities.getListFromStorage(theme.storageKeys.wishlistGuest),
        i = "";
      0 < t.length &&
        (t.forEach((n, r) => {
          i =
            (i += e.productContainerSelector
              .map(
                (t) => `${t}[data-product-id="${n}"]:not(.${e.inWishlistClass})`
              )
              .join(", ")) + (r === t.length - 1 ? "" : ",");
        }),
          document.querySelectorAll(i).forEach((t) => {
            t.classList.add(e.inWishlistClass);
          }));
    },
    addProduct: function (e) {
      let t = this,
        i = theme.utilities.getListFromStorage(theme.storageKeys.wishlistGuest);
      var n = this.productContainerSelector
        .map((i) => `${i}[data-product-id="${e}"]:not(.${t.inWishlistClass})`)
        .join(",");
      let r = document.querySelectorAll(n);
      0 < r.length &&
        r.forEach((e) => {
          e.classList.add(t.inWishlistClass);
        }),
        i.push(e),
        window.localStorage.setItem(
          theme.storageKeys.wishlistGuest,
          JSON.stringify(i)
        ),
        this.setCounter();
    },
    removeProduct: function (e) {
      let t = this,
        i = theme.utilities.getListFromStorage(theme.storageKeys.wishlistGuest),
        n =
          (0 < i.length &&
            (window.localStorage.setItem(
              theme.storageKeys.wishlistGuest,
              JSON.stringify(i.filter((t) => t !== e))
            ),
              this.setCounter()),
            document.querySelectorAll(
              `.${t.inWishlistClass}[data-product-id="${e}"]`
            ));
      0 < n.length &&
        n.forEach((e) => {
          e.classList.remove(t.inWishlistClass);
        }),
        document.querySelector(".wishlist-page") &&
        this.removeWishlistPageItem(e);
    },
    setCounter: function () {
      let e = document.querySelectorAll(".js-wishlist-counter");
      e &&
        e.forEach(function (e) {
          var t = theme.utilities.getListFromStorage(
            theme.storageKeys.wishlistGuest
          ).length;
          0 < (e.innerHTML = t)
            ? e.classList.remove("d-none")
            : e.classList.add("d-none");
        });
    },
    page: function () {
      let e = document.querySelector(".wishlist-page");
      if (e) {
        var t = theme.utilities
          .getListFromStorage(theme.storageKeys.wishlistGuest)
          .map((e) => "id:" + e)
          .join(" OR ");
        let i = e.querySelector(".wishlist-page__products");
        var n = i.dataset.sectionId;
        n = window.location.pathname + `?view=wishlist&section_id=${n}&q=` + t;
        let r = this;
        fetch(n)
          .then((e) => e.text())
          .then((e) => {
            let t = new DOMParser().parseFromString(e, "text/html");
            ((i.innerHTML = t.querySelector(
              ".wishlist-page__products"
            ).innerHTML),
              theme.utilities.imagesSrcset(i.getElementsByClassName("pr-image")),
              theme.utilities.applyAnimation(),
              i.classList.remove("d-none"),
              r.setInWishlistProduct(),
              i.querySelectorAll(".product-card")).forEach(function (e) {
                let t = Object.create(theme.product.card);
                (t.item = e), t.render();
              }),
              theme.component.renderTooltip(i);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    removeWishlistPageItem: function (e) {
      let t = document
        .querySelector(".wishlist-page__products")
        .querySelector(`.product-card[data-product-id="${e}"]`);
      t &&
        (t.querySelector(".js-add-wishlist").classList.add("d-none"),
          t.querySelector(".js-remove-wishlist").classList.add("d-none"),
          t.classList.add("opacity-0"),
          setTimeout(() => {
            t.remove();
          }, 500));
    },
  }),
  (theme.passwordPage = {
    passwordModal: document.querySelector(".password-modal"),
    render: function () {
      if (this.passwordModal) {
        let e = document.querySelector(".modal__toggle-open");
        e &&
          (e.addEventListener("click", this.showModal.bind(this)),
            this.passwordModal
              .querySelector(".modal-close-btn")
              .addEventListener("click", this.closeModal.bind(this)));
      }
    },
    showModal: function () {
      let e = this;
      this.passwordModal &&
        setTimeout(function () {
          e.passwordModal.classList.remove("hide", "fade-out");
          requestAnimationFrame(function () {
            e.passwordModal.classList.add("show");
            document.body.classList.add("noscroll");
          });
        }, 100);
    },
    closeModal: function (e) {
      e.preventDefault();
      let t = e.currentTarget.closest(".password-modal");
      t &&
        (t.classList.add("fade-out"),
          t.classList.remove("show"),
          setTimeout(function () {
            t.classList.add("hide"),
              t.classList.remove("fade-out"),
              document.body.classList.remove("noscroll");
          }, 300));
    },
  }),
  (theme.photoSwipe = {
    container: null,
    gallery: null,
    items: null,
    mediaIdToIndex: null,
    
    init: function(container) {
      this.container = container;

      try {
        const trigger = this.container && this.container.querySelector('[data-pswp-trigger]');
        const src = trigger && trigger.getAttribute('data-pswp');
        if (src && !window.PhotoSwipe && !window.__photoswipeLoaded && !window.__photoswipeLoading) {
          window.__photoswipeLoading = true;
          const script = document.createElement('script');
          script.src = src;
          script.async = true;
          script.onload = function () {
            window.__photoswipeLoaded = true;
            window.__photoswipeLoading = false;
          };
          script.onerror = function () {
            window.__photoswipeLoading = false;
            try { console.error('Erro ao carregar PhotoSwipe:', src); } catch (e) {}
          };
          document.head.appendChild(script);
        }
      } catch (e) {}
    },
    
    buildItems: function() {
      if (!this.container) return;
      const items = [];
      const map = {};
      
      const swiperContainer = this.container.querySelector('.product-media__swiper');
      if (swiperContainer) {
        const slides = swiperContainer.querySelectorAll('.swiper-wrapper .swiper-slide:not(.swiper-slide-duplicate)');
        slides.forEach((slide) => {
          const img = slide.querySelector('.main-product-media__thumbnail img');
          if (!img) return; 
          const src = img.getAttribute('data-original') || img.currentSrc || img.src;
          const widthAttr = parseInt(img.getAttribute('width'), 10);
          const heightAttr = parseInt(img.getAttribute('height'), 10);
          const width = widthAttr || img.naturalWidth || 1600;
          const height = heightAttr || img.naturalHeight || 1600;
          const mediaId = slide.getAttribute('data-media-id');
          map[mediaId] = items.length;
          items.push({ src: src, width: width, height: height, element: img });
        });
      } else {
        const singleMediaContainer = this.container.querySelector('.single-product-media');
        if (singleMediaContainer) {
          const img = singleMediaContainer.querySelector('.media img');
          if (img) {
            const src = img.getAttribute('data-original') || img.currentSrc || img.src;
            const widthAttr = parseInt(img.getAttribute('width'), 10);
            const heightAttr = parseInt(img.getAttribute('height'), 10);
            const width = widthAttr || img.naturalWidth || 1600;
            const height = heightAttr || img.naturalHeight || 1600;
            const mediaId = 'single-media';
            map[mediaId] = 0;
            items.push({ src: src, width: width, height: height, element: img });
          }
        }
      }
      
      this.items = items;
      this.mediaIdToIndex = map;
    },
    
    openGallery: function(index = 0) {
      this.buildItems();
      if (!this.items || this.items.length === 0) return;
    
      let targetIndex = index;
      
      const activeSlide = this.container.querySelector('.product-media__swiper .swiper-slide-active');
      if (activeSlide) {
        const activeMediaId = activeSlide.getAttribute('data-media-id');
        if (activeMediaId && this.mediaIdToIndex && this.mediaIdToIndex[activeMediaId] !== undefined) {
          targetIndex = this.mediaIdToIndex[activeMediaId];
        }
      } else {
        targetIndex = 0;
      }
    
      const gallery = new PhotoSwipe({
        dataSource: this.items,
        index: Math.max(0, Math.min(targetIndex, this.items.length - 1)),
        showHideAnimationType: 'fade',
        preloaderDelay: 0,
        zoom: false,
        close: false,
        loop: true,
        arrowPrevSVG: window.icons.arrowLeft,
        arrowNextSVG: window.icons.arrowRight,
        padding: {
          top: 70,
          bottom: 70,
          left: 0,
          right: 0
        }
      });
    
      gallery.on('init', function() {
        setTimeout(() => {
          if (gallery.ui && gallery.ui.registerElement) {
            gallery.ui.registerElement({
              name: 'custom-close',
              html: window.icons.close,
              order: 10,
              isButton: true,
              onClick: () => gallery.close(),
              appendTo: 'wrapper'
            });
          }
        }, 100);
      });
      
    
      gallery.init();
    }
    
  })
